import { useSnapshot } from "valtio";
import { myactionsstore } from "./store-myactions";
import TrackIcon from '../assets/images/track-icon.png'
import { bookingsStore, configStore } from "../state/CommonState";
import { OneDatetable, OneInput5table } from "../mytasks/act-common";
import { useEffect, useRef, useState } from "react";
import Api from "../state/Api";
import { DtStore } from "../dt/DtStore";
import { DtMap } from "../dt/DtMap";
import {origin_pickup_LCL,
  origin_pickup_fcl_FACTORY_FACTORY,
  origin_pickup_fcl_FACTORY_CFS,
  origin_pickup_fcl_CFS_FACTORY,
  origin_pickup_fcl_CFS_CFS,
  origin_pickup_AIR,
  destination_delivery_LCL,
  destination_delivery_fcl_FACTORY_FACTORY,
  destination_delivery_fcl_FACTORY_CFS,
  destination_delivery_fcl_CFS_CFS,
  destination_delivery_fcl_CFS_FACTORY,
  destination_delivery_AIR,
  gatein_mandatory_fields,
  getUpdatedFreezeFields} from './dsr_static'
import { ACTUALSLIST, arrayListsinDsr, SHIPMENT_SCOPE, SHIPMENT_TYPE } from "../util/constants";
import { loader } from "../util/loader";

const  VEHICLE_ROW_ERROR_DEFAULT = {
  origin: true,
  destination: true,
  driver_number: true,
  vehicle: true,
  number_of_package: true,
  total_package: true,
};
export function Vmodal({data, setIsDisabledForActualDD, 
  setIsDisabledForCargoPickup, originDisableStatus,
   setCargoPickUp, setActualDD, destinationDisableStatus}) {
  const booking = data;
  const por = data.por
  const pol = data.pol
  const IMPORT_BOOKING = booking?.booking?.destinationCount === "India"
  const EXPORT_BOOKING = booking?.booking?.originCount === "India"
  const LCL_OR_AIR = booking.shipmentType === 'LCL' || booking.shipmentType === 'Air'
  const LCL_EXPORT_TRANSPORT = booking.shipmentType === 'LCL' && booking.pol.startsWith('US') && booking.ltlversion !== undefined && booking.ltlversion === 'Yes' 
  const LCL_IMPORT_TRANSPORT = booking.shipmentType === 'LCL' && booking.fpod.startsWith('US') && booking.ltlversion !== undefined && booking.ltlversion === 'Yes'
  const AIR_EXPORT_TRANSPORT = booking.shipmentType === 'Air' && booking.departure_airport.startsWith('US') && booking.ltlversion !== undefined && booking.ltlversion === 'Yes'
  const AIR_IMPORT_TRANSPORT = booking.shipmentType === 'Air' && booking.arrival_airport.startsWith('US') && booking.ltlversion !== undefined && booking.ltlversion === 'Yes'
  console.log("props-------->", booking.shipmentType, booking);
  
  let originDateSelector;

  let originDateSelector_Index = {
    arrival_factory: "Arrival @ Factory",
    cargo_pickup: "Cargo Pickup",
    actual_time_arrival_at_warehouse: "ATA @ Warehouse 1",
  };
  let originDateSelector_LastIndex_For_LCL = {
    cargo_departed_for_port: "Cargo Departured for Port",
    cargo_arrival_cfs: "Cargo arrival at CFS",
  };
  let originDateSelector_LastIndex_For_Air = {
    cargo_departed_for_port: "Cargo Departured for AirPort",
    arrival_dispatch_airport: "Arrival @ Dispatch Airport",
  };
  let destinationDateSelector_Index_For_LCL = {
    loaded_cfs: "Loaded @ CFS",
    atdfrompod: "Cargo Picked-up for Delivery",
    actual_time_arrival_at_warehouse: "ATA @ Warehouse 1",
  };
  let destinationDateSelector_Index_For_Air = {
    dispatched_from_arrival_airport: "Dispatched from Arrival Airport	",
    actual_time_arrival_at_warehouse: "ATA @ Warehouse 1",
  };
  let destinationDateSelector_LastIndex = {
    cargo_departure_from_warehouse: 'Cargo departure from warehouse',
    estimate_delivery_date_to_consignee: "Est. Delivery Date to Consignee",
    actual_delivery_date: "Actual delivery date",
  };
  if (booking.shipmentType === SHIPMENT_TYPE.lcl) {
    originDateSelector = origin_pickup_LCL;
  }
  if (booking.shipmentType === SHIPMENT_TYPE.fcl_f_f) {
    originDateSelector = origin_pickup_fcl_FACTORY_FACTORY;
  }
  if (booking.shipmentType === SHIPMENT_TYPE.fcl_f_cfs) {
    originDateSelector = origin_pickup_fcl_FACTORY_CFS;
  }
  if (booking.shipmentType === SHIPMENT_TYPE.fcl_cfs_cfs) {
    originDateSelector = origin_pickup_fcl_CFS_CFS;
  }
  if (booking.shipmentType === SHIPMENT_TYPE.fcl_cfs_f) {
    originDateSelector = origin_pickup_fcl_CFS_FACTORY;
  }
  if (booking.shipmentType === SHIPMENT_TYPE.air) {
    originDateSelector = origin_pickup_AIR;
  }

  let destinationDateSelector;
  if (booking.shipmentType === SHIPMENT_TYPE.lcl) {
    destinationDateSelector = destination_delivery_LCL;
  }
  if (booking.shipmentType === SHIPMENT_TYPE.fcl_f_f) {
    destinationDateSelector = destination_delivery_fcl_FACTORY_FACTORY;
  }
  if (booking.shipmentType === SHIPMENT_TYPE.fcl_f_cfs) {
    destinationDateSelector = destination_delivery_fcl_FACTORY_CFS;
  }
  if (booking.shipmentType === SHIPMENT_TYPE.fcl_cfs_cfs) {
    destinationDateSelector = destination_delivery_fcl_CFS_CFS;
  }
  if (booking.shipmentType === SHIPMENT_TYPE.fcl_cfs_f) {
    destinationDateSelector = destination_delivery_fcl_CFS_FACTORY;
  }
  if (booking.shipmentType === SHIPMENT_TYPE.air) {
    destinationDateSelector = destination_delivery_AIR;
  }
  useSnapshot(myactionsstore);
  useSnapshot(DtStore);
  useSnapshot(configStore);
  let ret = configStore.modalvisibledata;
  let st = ret.shipmentType;
  let sc = ret.shipmentScope;
  let tto = ret.transportTypeOrigin ? ret.transportTypeOrigin : 'FTL'
  let ttd = ret.transportTypeDestination ? ret.transportTypeDestination : 'FTL'
  const multidest = booking?.booking?.contract?.multidest
  const [ch, setCh] = useState(0);
  const [origin, setOrgin] = useState([]);
  const [des, setDes] = useState([]);
  const [multipleDes, setMultipleDes] = useState([]);
  const [originDisable, setOriginDisable] = useState(setIsDisabledForCargoPickup.length === 0  ? [] : setIsDisabledForCargoPickup)
  const [destinationDisable, setDestinationDisable] = useState(setIsDisabledForActualDD.length === 0  ? [] : setIsDisabledForActualDD)
  // const [disable, setDisable] = useState(isValueTrue)
  const [isPicked, setisPicked] = useState(false);
  const [mailPickup, setMailPickup] = useState(false);
  const [mailDelivery, setMailDelivery] = useState(false);
  const [isDelivered, setisDelivered] = useState(false);
  const [deliveryMailed, setDeliveryMailed] = useState(false);
  const [pickupMailed, setPickupMailed] = useState(false);
  const [mapVisible, setMapVisible] = useState(false);
  const [total_package, setTotalPackage] = useState(false);
  const [originError, setOriginError] = useState([]);
  const [destinationError, setDestinationError] = useState([]);
  const [multidestError, setMultiDestError] = useState([]);
  const [originWarehouses, setOriginWarehouses] = useState([]);
  const [destinationWarehouses, setDestinationWarehouses] = useState([]);
  const [originOrder, setOriginOrder] = useState(false); 
  const [destinationOrder, setDestinationOrder] = useState(false); 
  const [transportTypeOrigin, setTransportTypeOrigin] = useState(tto);
  const [transportTypeDestination, setTransportTypeDestination] = useState(ttd);
  const [clearData, setClearData] = useState(false);
  const [clearType, setClearType] = useState('');
  const [originDateSelectorForLTL, setOriginDateSelectorForLTL] = useState([]);
  const [destinationDateSelectorForLTL, setDestinationDateSelectorForLTL] = useState([]);
  const updatedFreezeFieldsRef = useRef(gatein_mandatory_fields);
  const today = new Date().toISOString().split("T")[0];

  console.log("sc---------?", ret);
  console.log("originInitial---------?", booking.vorgin);
  console.log("originInitial else---------?", booking.vdes);
  let b = booking?.booking;
  useEffect(() => {
    setOriginOrder(false);
    let origin_destination = ""
    
    if(b?.contract?.portOfReceipt.trim().length==0){
        origin_destination = b?.contract?.portOfLoading
    }else{
        origin_destination = b?.contract?.portOfReceipt
    }
    
    let originInitial = new Array();
    if ((booking?.vorgin === undefined || booking?.vorgin?.length === 0) 
      && (sc === SHIPMENT_SCOPE.d2p || sc === SHIPMENT_SCOPE.d2d) && st != SHIPMENT_TYPE.fcl_f_cfs) {
      let temp = EXPORT_BOOKING ? 
      {terminal_cfs : origin_destination, destination: '',} : {destination: origin_destination}
      let transport = LCL_EXPORT_TRANSPORT || AIR_EXPORT_TRANSPORT ? {transport_ref_number: '', transport_name: ''} : {}
      originInitial.push({
        origin: booking.origin,
        transport_ref_number: "",
        transport_name: "",
        driver_number: "",
        driver_name: "",
        vehicle: "",
        number_of_package: "",
        status: "",
        total_package: booking?.booking?.contract?.cargoList?.reduce((sum, cargo) => sum + (+cargo.numPackages), 0),
        ...temp,
        ...transport,
        ...Object.keys(originDateSelector).reduce((ele, key) => {
          ele[key] = "";
          return ele;
        }, {}),
      })
    }else if (booking?.vorgin && booking?.vorgin?.length > 0 
      && (sc === SHIPMENT_SCOPE.d2p || sc === SHIPMENT_SCOPE.d2d) && (st != SHIPMENT_TYPE.fcl_f_cfs)) {
      originInitial = booking?.vorgin;
      console.log("check login-------->")
      originInitial.forEach((ele, index, originInitialArr) => {
        ele[transportTypeOrigin === 'LTL' ? index === 0 ? 'origin' : index + 1  === originInitialArr.length && originInitialArr.length > 1 ? `warehouse_${index}` : `warehouse_${index}` : 'origin' ] = ele[transportTypeOrigin === 'LTL' ? index === 0 ? 'origin' : index + 1  === originInitialArr.length && originInitialArr.length > 1 ? `warehouse_${index}` : `warehouse_${index}` : 'origin' ] === undefined ? '' : ele[transportTypeOrigin === 'LTL' ? index === 0 ? 'origin' : index + 1  === originInitialArr.length && originInitialArr.length > 1 ? `warehouse_${index}` : `warehouse_${index}` : 'origin' ];
        ele[transportTypeOrigin === 'LTL' ? index+1 === originInitialArr.length ? 'destination' : `warehouse_${index+1}` : 'desination'] = ele[transportTypeOrigin === 'LTL' ? index+1 === originInitialArr.length ? 'destination' : `warehouse_${index+1}` : 'desination'] === undefined ? '' : ele[transportTypeOrigin === 'LTL' ? index+1 === originInitialArr.length ? 'destination' : `warehouse_${index+1}` : 'desination'];
        ele.driver_number = ele.driver_number === undefined ? "" : ele.driver_number;
        ele.driver_name = ele.driver_name === undefined ? "" : ele.driver_name;
        ele.vehicle = ele.vehicle === undefined ? "" : ele.vehicle;
        ele.number_of_package = ele.number_of_package === undefined ? "" : ele.number_of_package;
        ele.status = ele.status === undefined ? "" : ele.status;
        ele.total_package = ele.total_package > 0 ? ele.total_package : 
        booking?.booking?.contract?.cargoList?.reduce((sum, cargo) => sum + (+cargo.numPackages), 0);
        if(LCL_EXPORT_TRANSPORT || AIR_EXPORT_TRANSPORT){
          ele.transport_ref_number = ele.transport_ref_number === undefined ? "" : ele.transport_ref_number;
          ele.transport_name = ele.transport_name === undefined ? "" : ele.transport_name;
        }
        if(transportTypeOrigin === 'LTL' && EXPORT_BOOKING && LCL_OR_AIR && index + 1  === originInitialArr.length) {
          ele.terminal_cfs = origin_destination
        }
        if((transportTypeOrigin === 'FTL' && EXPORT_BOOKING) || (!LCL_OR_AIR && EXPORT_BOOKING)){
          ele.terminal_cfs = origin_destination
        }
      })
    }
    if(originDateSelector.cargo_pickup && !originDisableStatus){
      let check = originInitial.map((ele) => ele.cargo_pickup === "");
      setOriginDisable(check)
      setCargoPickUp(check)
    }
    console.log("originInitial------------------------", originInitial)
    setOrgin(originInitial);
    if(transportTypeOrigin === 'LTL' && (st === 'LCL' || st === 'Air') && ret?.vorgin?.length > 1){
      let arr = [];
      ret.vorgin.forEach((_, index, array) => {
        if(index === 0){
          arr.push(array.length === 1 ? st === 'LCL' ? origin_pickup_LCL : origin_pickup_AIR : originDateSelector_Index)
        }else if((index+1) === array.length && array.length > 1){
          arr.push(st === 'LCL' ? originDateSelector_LastIndex_For_LCL : originDateSelector_LastIndex_For_Air)
        }else{
          arr.push({
            actual_time_departed: `ATD @ Warehouse ${index}`,
            actual_time_arrival: `ATA @ Warehouse ${index+1}`,
          })
        }
      })
      let initialWHUpdate = [];
      ret.vorgin.forEach((_, index) => {
        if(index !== 0) initialWHUpdate.push(`Warehouse ${index}`)
      })
      setOriginWarehouses(initialWHUpdate)
      setOriginDateSelectorForLTL(arr)
    }
    setOriginError(originInitial.map(ele => (booking.shipmentType ===  SHIPMENT_TYPE.lcl ? {...VEHICLE_ROW_ERROR_DEFAULT, vehicle: true, driver_number: true} : VEHICLE_ROW_ERROR_DEFAULT)))
    
  }, [originOrder])
  useEffect(() =>{
    setDestinationOrder(false)
    let destination_origin = ""
    if(b?.contract?.finalPlaceOfDelivery.trim().length==0){
        destination_origin = b?.contract?.portOfDischarge
    }else{
        destination_origin = b?.contract?.finalPlaceOfDelivery
    }
    let destinationInitial = new Array();
    if ((booking?.vdes === undefined || booking?.vdes?.length === 0) && (sc == SHIPMENT_SCOPE.p2d || sc == SHIPMENT_SCOPE.d2d) 
      && st != SHIPMENT_TYPE.fcl_cfs_f && (multidest?.length === 1 || multidest === undefined)) {
        let temp = IMPORT_BOOKING ? {terminal_cfs : destination_origin, origin: ''} : {origin: destination_origin}
        let transport = LCL_IMPORT_TRANSPORT || AIR_IMPORT_TRANSPORT ? {transport_ref_number: '', transport_name: ''} : {};
        destinationInitial.push({
          destination: booking.destination,
          driver_number: "",
          driver_name: "",
          vehicle: "",
          number_of_package: "",
          status: "",
          total_package: booking?.booking?.contract?.cargoList?.reduce((sum, cargo) => sum + (+cargo.numPackages), 0),
          ...temp,
          ...transport,
          ...Object.keys(destinationDateSelector).reduce((ele, key) => {
            ele[key] = "";
            return ele;
          }, {}),
        })
        if(booking.shipmentType === SHIPMENT_TYPE.fcl_cfs_cfs || booking.shipmentType === SHIPMENT_TYPE.fcl_f_cfs){
          destinationInitial[0].container_number_vehicle = "";
        }
    }else if (booking?.vdes?.length > 0 && (sc == SHIPMENT_SCOPE.p2d || sc == SHIPMENT_SCOPE.d2d) && 
      st != SHIPMENT_TYPE.fcl_cfs_f && (multidest === undefined || multidest?.length === 1) ) {
      destinationInitial = booking?.vdes;
      console.log("ret.vdes----------> 111111", booking?.vdes)
      destinationInitial.forEach((ele, index, destinationInitialArr) => {
        ele[transportTypeDestination === 'LTL' ? index === 0 ? 'origin' : index + 1  === destinationInitialArr.length && destinationInitialArr.length > 1 ? `warehouse_${index}` : `warehouse_${index}` : 'origin' ] = ele[transportTypeDestination === 'LTL' ? index === 0 ? 'origin' : index + 1  === destinationInitialArr.length && destinationInitialArr.length > 1 ? `warehouse_${index}` : `warehouse_${index}` : 'origin' ] === undefined ? '' : ele[transportTypeDestination === 'LTL' ? index === 0 ? 'origin' : index + 1  === destinationInitialArr.length && destinationInitialArr.length > 1 ? `warehouse_${index}` : `warehouse_${index}` : 'origin' ];
        ele[transportTypeDestination === 'LTL' ? index+1 === destinationInitialArr.length ? 'destination' : `warehouse_${index+1}` : 'desination'] = ele[transportTypeDestination === 'LTL' ? index+1 === destinationInitialArr.length ? 'destination' : `warehouse_${index+1}` : 'desination'] === undefined ? '' : ele[transportTypeDestination === 'LTL' ? index+1 === destinationInitialArr.length ? 'destination' : `warehouse_${index+1}` : 'desination'];
        ele.transport_ref_number = ele.transport_ref_number === undefined ? "" : ele.transport_ref_number;
        ele.transport_name = ele.transport_name === undefined ? "" : ele.transport_name;
        ele.driver_number = ele.driver_number === undefined ? "" : ele.driver_number;
        ele.driver_name = ele.driver_name === undefined ? "" : ele.driver_name;
        ele.vehicle = ele.vehicle === undefined ? "" : ele.vehicle;
        ele.number_of_package = ele.number_of_package === undefined ? "" : ele.number_of_package;
        ele.status = ele.status === undefined ? "" : ele.status;
        ele.total_package = ele.total_package > 0 ? ele.total_package :
        booking?.booking?.contract?.cargoList?.reduce((sum, cargo) => sum + (+cargo.numPackages), 0);

        if(LCL_IMPORT_TRANSPORT || AIR_IMPORT_TRANSPORT){
          ele.transport_ref_number = ele.transport_ref_number === undefined ? "" : ele.transport_ref_number;
          ele.transport_name = ele.transport_name === undefined ? "" : ele.transport_name;
        }
        if(transportTypeDestination === 'LTL' && IMPORT_BOOKING && LCL_OR_AIR && index === 0) {
          ele.terminal_cfs = destination_origin
        }
        if((transportTypeDestination === 'FTL' && IMPORT_BOOKING) || (!LCL_OR_AIR && IMPORT_BOOKING)){
          ele.terminal_cfs = destination_origin
        }
      })
      if(booking.shipmentType === SHIPMENT_TYPE.fcl_cfs_cfs || booking.shipmentType === SHIPMENT_TYPE.fcl_f_cfs){
        destinationInitial.forEach((ele) => {
          ele.container_number_vehicle = ele.container_number_vehicle === undefined ? "" : ele.container_number_vehicle;
        })
      }
    }
    if(destinationDateSelector.actual_delivery_date && !destinationDisableStatus){
      let check = transportTypeDestination === 'LTL' ?
        [destinationInitial.some(e => e.actual_delivery_date === "")] :
        destinationInitial.map((ele) => ele.actual_delivery_date === "")
      setDestinationDisable(check)
      setActualDD(check)
    }
    console.log("destinationInitial------------------------", destinationInitial)
    setDes(destinationInitial);
    if(transportTypeDestination === 'LTL' && (st === 'LCL' || st === 'Air') && ret?.vdes?.length > 1){
      let arr = [];
      ret.vdes.forEach((_, index, array) => {
        if(index === 0){
          if(array.length === 1){
            arr.push(st === 'LCL' ? destination_delivery_LCL : destination_delivery_AIR)
          }else{
            arr.push(st === 'LCL' ? destinationDateSelector_Index_For_LCL : destinationDateSelector_Index_For_Air)
          }  
        }else if((index+1) === array.length && array.length > 0){
          arr.push(destinationDateSelector_LastIndex)
        }else{
          arr.push({
            actual_time_departed: `ATD @ Warehouse ${index}`,
            actual_time_arrival: `ATA @ Warehouse ${index + 1}`,
          })
        }
      })
      let initialWHUpdate = [];
      ret.vdes.forEach((_, index) => {
        if(index !== 0) initialWHUpdate.push(`Warehouse ${index}`)
      })
      setDestinationWarehouses(initialWHUpdate)
      setDestinationDateSelectorForLTL(arr)
    }
    
    if(booking.shipmentType === SHIPMENT_TYPE.fcl_cfs_cfs || booking.shipmentType === SHIPMENT_TYPE.fcl_f_cfs){
      let errorMap = VEHICLE_ROW_ERROR_DEFAULT;
      errorMap.container_number_vehicle = true;
      setDestinationError(destinationInitial.map(ele => errorMap))
    }else{
      setDestinationError(destinationInitial.map(ele => booking.shipmentType ===  SHIPMENT_TYPE.lcl ? 
        {...VEHICLE_ROW_ERROR_DEFAULT, vehicle: true, driver_number: true} : VEHICLE_ROW_ERROR_DEFAULT))
    }
    let multipleDestinationInitial = new Array();
    let destination;
    if((booking?.vdes === undefined || booking?.vdes.length === 0) && multidest?.length > 1 
    && (sc == SHIPMENT_SCOPE.p2d || sc == SHIPMENT_SCOPE.d2d) && st != SHIPMENT_TYPE.fcl_cfs_f){
      multidest.forEach((ele, index) => {
        let temp = IMPORT_BOOKING ? {terminal_cfs : destination_origin, origin: ''} : {origin: destination_origin}
        let transport = LCL_IMPORT_TRANSPORT || AIR_IMPORT_TRANSPORT ? {transport_ref_number: '', transport_name: ''} : {};
        destination = [{
          destination: ele.destination,
          driver_number: "",
          driver_name: "",
          vehicle: "",
          number_of_package: "",
          status: "",
          total_package: ele.cargoDetails.reduce((sum, cargo) => sum + (+cargo.numPackages), 0),
          ...temp,
          ...transport,
          ...Object.keys(destinationDateSelector).reduce((selector, key) => {
            selector[key] = "";
            return selector;
          }, {}),
        }];
        if(booking.shipmentType === SHIPMENT_TYPE.fcl_cfs_cfs || booking.shipmentType === SHIPMENT_TYPE.fcl_f_cfs){
          destination[0].container_number_vehicle = "";
        }
        multipleDestinationInitial.push(destination)
      })
      
    }
    else if(booking?.vdes && multidest?.length > 1 && 
      (sc == SHIPMENT_SCOPE.p2d || sc == SHIPMENT_SCOPE.d2d) && st != SHIPMENT_TYPE.fcl_cfs_f){
      let a = []
      for (let i = 0; i < multidest?.length; i++) {
          if(i==0){
              if(booking.vdes != undefined && booking.vdes.length > 0) {
                  a.push(booking.vdes)
              }
          }else{
              let k = i+1
              if(booking['vdes'+k] != undefined && booking['vdes'+k].length > 0) {
                  a.push(booking['vdes'+k])
              }
          }
      }
      multipleDestinationInitial = a;
      if(transportTypeDestination === 'LTL'){
        let warehouse = new Array();
        multipleDestinationInitial.forEach((ele, index) => {
          let temp = new Array();
          if(ele.length > 1){
            ele.forEach((e, i) => i !== 0 ? temp.push(`warehouse ${i}`) : null)
            warehouse.push(temp);
          }else{
            warehouse.push([]);
          }
        })
        setDestinationWarehouses(warehouse);

        let tempDateArray = []
        multipleDestinationInitial.forEach((ele, index) => {
            let arr = [];
            ele.forEach((_, index, array) => {
              if(index === 0){
                if(array.length === 1){
                  arr.push(st === 'LCL' ? destination_delivery_LCL : destination_delivery_AIR)
                }else{
                  arr.push(st === 'LCL' ? destinationDateSelector_Index_For_LCL : destinationDateSelector_Index_For_Air)
                }
              }else if((index+1) === array.length && array.length > 1){
                arr.push(destinationDateSelector_LastIndex)
              }else{
                arr.push({
                  actual_time_departed: `ATD @ Warehouse ${index}`,
                  actual_time_arrival: `ATA @ Warehouse ${index + 1}`,
                })
              }
            })
            tempDateArray.push(arr)
        })
        multipleDestinationInitial = multipleDestinationInitial.map(innerArray =>
        innerArray.map((obj, index) => index === 0 && IMPORT_BOOKING
        ? {...obj, terminal_cfs: destination_origin} : {...obj}));
        setDestinationDateSelectorForLTL(tempDateArray)
      }
      
    }
    if(multipleDestinationInitial.length > 0 && destinationDateSelector.actual_delivery_date && !destinationDisableStatus){
      let check = transportTypeDestination === 'LTL' ? 
      multipleDestinationInitial.map((ele) => [ele.some(e => e.actual_delivery_date === "")]) 
      : multipleDestinationInitial.map((ele) => ele.map(e => e.actual_delivery_date === ""));
      setDestinationDisable(check)
      setActualDD(check)
    }
    setMultipleDes(multipleDestinationInitial)
    
    if(booking.shipmentType === SHIPMENT_TYPE.fcl_cfs_cfs || booking.shipmentType === SHIPMENT_TYPE.fcl_f_cfs){
      let errorMap = [VEHICLE_ROW_ERROR_DEFAULT];
      errorMap[0].container_number_vehicle = true;
      setMultiDestError(multipleDestinationInitial?.map(ele => ele.map(e => errorMap)));
    }else{
      setMultiDestError(multipleDestinationInitial?.map(ele => ele.map(e => VEHICLE_ROW_ERROR_DEFAULT)));
    }
  }, [destinationOrder])
      const shipmentYettoStart = configStore.modalvisibledata?.booking?.status === "SUBMITTED"
  const areAllCargoPickupFilled = () => {
    // Check if any cargo_pickup field is empty
    for (let i = 0; i < origin.length; i++) {
      if (!origin[i].cargo_pickup) {
        return false; // Return false if any cargo_pickup field is empty
      }
    }
    return true; // Return true if all cargo_pickup fields are filled
  };
  const areAllCargoDeliveryFilled = () => {
    // Check if any cargo_pickup field is empty
    for (let i = 0; i < des.length; i++) {
      if (!des[i].actual_delivery_date) {
        return false; // Return false if any cargo_pickup field is empty
      }
    }
    return true; // Return true if all cargo_pickup fields are filled
  };
  useEffect(() => {
    const updatedFreeze = getUpdatedFreezeFields(
        gatein_mandatory_fields,
        st,
        sc,
        por,
        pol
    );
    updatedFreezeFieldsRef.current = updatedFreeze.updatedFreeze
}, [st, sc, por, pol]);
  const handlePicked = () => {
    if (areAllCargoPickupFilled()) {
      setisPicked(!isPicked);
    } else {
      setMailPickup(false);
      setisPicked(false);
    }
  };

  const handlePickToggle = () => {
    if (areAllCargoPickupFilled()) {
      setMailPickup(!mailPickup);
    } else {
      setMailPickup(false);
    }
  };
  const handleDeliveryToggle = () => {
    if (areAllCargoDeliveryFilled()) {
      setMailDelivery(!mailDelivery);
    } else {
      setMailDelivery(false);
    }
  };
  const handleDelivered = () => {
    if (areAllCargoDeliveryFilled()) {
      setisDelivered(!isDelivered);
    } else {
      setisDelivered(false);
    }
  };
  const seorde = () => {
    setPickupMailed(ret.picked !== true);
    setDeliveryMailed(ret.delivered !== true);
    if (sc == SHIPMENT_SCOPE.p2d || sc == SHIPMENT_SCOPE.d2d) {
      if (ret.vdes != undefined && ret.vdes.length > 0) {
        setDes(ret.vdes);
      }
    }
    if (sc == SHIPMENT_SCOPE.d2p || sc == SHIPMENT_SCOPE.d2d) {
      if (ret.vorigin != undefined && ret.vorigin.length > 0) {
        setOrgin(ret.vorigin);
      }
    }
    changech();
  };

  const changech = () => {
    if (ch == 0) {
      setCh(1);
    } else {
      setCh(0);
    }
  };

  const add1 = (e, key) => {
    e.preventDefault()
    let origin_destination = ""
    let b = booking?.booking
    if(b?.contract?.portOfReceipt.trim().length==0){
      origin_destination = b?.contract?.portOfLoading
    }else{
      origin_destination = b?.contract?.portOfReceipt
    }
    let temp = EXPORT_BOOKING ? {terminal_cfs: origin_destination} : {};
    let o = {
      origin: booking.origin,
      destination: EXPORT_BOOKING ? '' : origin_destination,
      driver_number: "",
      driver_name: "",
      vehicle: "",
      number_of_package: "",
      status: "",
      ...temp,
      total_package: (booking?.booking?.contract?.cargoList || []).reduce(
        (sum, cargo) => sum + (+cargo.numPackages || 0),
        0
      ),
    };
    if(key === 'addWareHouses'){ 
      const newWarehouse = `Warehouse ${originWarehouses.length + 1}`;
      setOriginWarehouses([...originWarehouses, newWarehouse]);
      let cloneOrigin = [...origin]
      let upadateOriginWH = [];
      let originDateSelectorArray = [originDateSelector_Index];
      let transportForInitial = LCL_EXPORT_TRANSPORT || AIR_EXPORT_TRANSPORT ? 
      { transport_ref_number: cloneOrigin[0].transport_ref_number, transport_name: cloneOrigin[0].transport_name } : {};
      upadateOriginWH.push({
        origin: booking.origin,
        warehouse_1: cloneOrigin[0].warehouse_1 === undefined ? '' : cloneOrigin[0].warehouse_1,
        driver_number: cloneOrigin[0].driver_number,
        driver_name: cloneOrigin[0].driver_name,
        vehicle: cloneOrigin[0].vehicle,
        number_of_package: cloneOrigin[0].number_of_package,
        status: cloneOrigin[0].status,
        arrival_factory: cloneOrigin[0].arrival_factory ? cloneOrigin[0].arrival_factory : '', 
        cargo_pickup: cloneOrigin[0].cargo_pickup ? cloneOrigin[0].cargo_pickup : '', 
        actual_time_arrival_at_warehouse: cloneOrigin[0].actual_time_arrival_at_warehouse ? cloneOrigin[0].actual_time_arrival_at_warehouse : '',
        total_package: (booking?.booking?.contract?.cargoList || []).reduce(
          (sum, cargo) => sum + (+cargo.numPackages || 0),
          0
        ),
        ...transportForInitial
      });
      
      origin.forEach((_, index, arr) => {
        let isLast = index + 1 === arr.length;

        let tempDateSelector = st === 'LCL' ? 
        {cargo_arrival_cfs: cloneOrigin[index].cargo_arrival_cfs ? cloneOrigin[index].cargo_arrival_cfs : ''} 
        : st === 'Air' ? {arrival_dispatch_airport: cloneOrigin[index].arrival_dispatch_airport ? cloneOrigin[index].arrival_dispatch_airport : ''} : {};
        let transport = (LCL_EXPORT_TRANSPORT || AIR_EXPORT_TRANSPORT) ? arr.length > 1 ? index+1 === arr.length ? {transport_ref_number: '', transport_name: ''} :
        { transport_ref_number: cloneOrigin[index+1].transport_ref_number, transport_name: cloneOrigin[index+1].transport_name } 
        : { transport_ref_number: '', transport_name: '' } : {}
        let originDateSelector = isLast
          ? {
            [`warehouse_${arr.length}`]: '',
            destination: EXPORT_BOOKING ? cloneOrigin[index].destination : origin_destination,
            driver_number: "",
            driver_name: "",
            vehicle: "",
            number_of_package: cloneOrigin[0].number_of_package,
            status: "",
            cargo_departed_for_port: "", 
            total_package: (booking?.booking?.contract?.cargoList || []).reduce(
              (sum, cargo) => sum + (+cargo.numPackages || 0),
              0
            ),
            ...temp,
            ...transport,
            ...tempDateSelector,
          }
          : { 
              [`warehouse_${index + 1}`]: cloneOrigin[index+1][`warehouse_${index + 1}`],
              [`warehouse_${index + 2}`]: cloneOrigin[index+1][`warehouse_${index + 2}`],
              driver_number: cloneOrigin[index+1].driver_number,
              driver_name: cloneOrigin[index+1].driver_name,
              vehicle: cloneOrigin[index+1].vehicle,
              number_of_package: cloneOrigin[0].number_of_package,
              status: cloneOrigin[index+1].status,
              actual_time_departed: cloneOrigin[index+1].actual_time_departed ? cloneOrigin[index+1].actual_time_departed : '',
              actual_time_arrival: cloneOrigin[index+1].actual_time_arrival ? cloneOrigin[index+1].actual_time_arrival : '',
              total_package: (booking?.booking?.contract?.cargoList || []).reduce(
                (sum, cargo) => sum + (+cargo.numPackages || 0),
                0
              ),
              ...transport
            };
        let originDateSelectorArr = isLast
        ? st === 'LCL' ? originDateSelector_LastIndex_For_LCL : st === 'Air' ? originDateSelector_LastIndex_For_Air : {}
        : {
          actual_time_departed: `ATD @ Warehouse ${index + 1}`,
          actual_time_arrival: `ATA @ Warehouse ${index + 2}`,
          };
      
        upadateOriginWH.push(originDateSelector);
        originDateSelectorArray.push(originDateSelectorArr);
      });
      setOrgin(upadateOriginWH)
      setOriginDateSelectorForLTL(originDateSelectorArray)
      setOriginError([...originError, VEHICLE_ROW_ERROR_DEFAULT]);
    }else{
      let updateOrigin = {
        ...o,
        ...Object.keys(originDateSelector).reduce((ele, key) => {
          ele[key] = "";
          return ele;
        }, {}),
      };
      setOriginError([...originError, VEHICLE_ROW_ERROR_DEFAULT]);
      setOrgin([...origin, updateOrigin]);
    }
    
  };

  const del1 = (id, key) => {
    console.log("check arr------------", id, key)
    if(key === 'deleteWarehouse'){
        setOriginWarehouses((prevWarehouses) =>
          prevWarehouses
            .filter((_, i) => i !== id)
            .map((_, i) => `Warehouse ${i + 1}`)
        );
        let origin_destination = ""
        let b = booking?.booking
        if(b?.contract?.portOfReceipt.trim().length==0){
          origin_destination = b?.contract?.portOfLoading
        }else{
          origin_destination = b?.contract?.portOfReceipt
        }
        let o = {
          origin: booking.origin,
          destination: origin_destination,
          driver_number: "",
          driver_name: "",
          vehicle: "",
          number_of_package: "",
          status: "",
          total_package: (booking?.booking?.contract?.cargoList || []).reduce(
            (sum, cargo) => sum + (+cargo.numPackages || 0),
            0
          ),
        };
        let arr = []
        let Date = []
        let cloneDate = [...originDateSelectorForLTL]
        let cloneOrigin = [...origin]
        let filterDate = cloneDate.filter((_, i) => i !== id)
        let filterOrigin = cloneOrigin.filter((_, i) => i !== id)
        filterDate.forEach((_, index, array) => {
          if(index === 0){
            Date.push(array.length === 1 ? st === 'LCL' ? origin_pickup_LCL : origin_pickup_AIR : originDateSelector_Index)
          }else if((index+1) === array.length && array.length > 1){
            Date.push(st === 'LCL' ? originDateSelector_LastIndex_For_LCL : originDateSelector_LastIndex_For_Air)
          }else{
            Date.push({
              actual_time_departed: `ATD @ Warehouse ${index}`,
              actual_time_arrival: `ATA @ Warehouse ${index}`,
            })
          }
        })
        filterOrigin.forEach((_, index, array) => {
          let transport = LCL_EXPORT_TRANSPORT || AIR_IMPORT_TRANSPORT ?
          { transport_ref_number: filterOrigin[index].transport_ref_number, transport_name: filterOrigin[index].transport_name } : {};
          if(index === 0){
            let temp = array.length === 1 ? st === 'LCL' ? {cargo_arrival_cfs: ''} 
            : { arrival_dispatch_airport: ''} : {actual_time_arrival_at_warehouse: ''}
            let terminal = array.length === 1 ? {terminal_cfs: origin_destination,} : {}
            arr.push({
              origin: booking.origin,
              [array.length === 1 ? 'destination' : 'warehouse_1']: array.length === 1 ? EXPORT_BOOKING ? filterOrigin[index].destination : '' : filterOrigin[index][array.length === 1 ? 'destination' : 'warehouse_1'],
              driver_number: filterOrigin[index].driver_number,
              driver_name: filterOrigin[index].driver_name,
              vehicle: filterOrigin[index].vehicle,
              number_of_package: filterOrigin[index].number_of_package,
              status: "",
              arrival_factory: filterOrigin[index].arrival_factory ? filterOrigin[index].arrival_factory : '',
              cargo_pickup: filterOrigin[index].cargo_pickup ? filterOrigin[index].cargo_pickup : '',
              ...temp,
              ...terminal,
              ...transport,
              total_package: (booking?.booking?.contract?.cargoList || []).reduce(
                (sum, cargo) => sum + (+cargo.numPackages || 0),
                0
              ),
            })
          }else if((index+1) === array.length && array.length > 1){
            console.log("filterOrigin------> last", filterOrigin[index-1])
            console.log("filterOrigin------> last", filterOrigin[index][`warehouse_${index}`])
            arr.push({
              [`warehouse_${index}`]: filterOrigin[index][`warehouse_${index}`] === undefined ? filterOrigin[index-1][`warehouse_${index}`]: filterOrigin[index][`warehouse_${index}`],
              terminal_cfs: origin_destination,
              destination: filterOrigin[index].destination,
              driver_number: filterOrigin[index].driver_number,
              driver_name: filterOrigin[index].driver_name,
              vehicle: filterOrigin[index].vehicle,
              number_of_package: filterOrigin[index].number_of_package,
              status: "",
              cargo_departed_for_port: filterOrigin[index].cargo_departed_for_port ? filterOrigin[index].cargo_departed_for_port : '',
              cargo_arrival_cfs: filterOrigin[index].cargo_arrival_cfs ? filterOrigin[index].cargo_arrival_cfs : '',
              ...transport,
              total_package: (booking?.booking?.contract?.cargoList || []).reduce(
                (sum, cargo) => sum + (+cargo.numPackages || 0),
                0
              ),
            })
          }else{
            console.log("filterOrigin------>", filterOrigin[index])
            arr.push({
              [`warehouse_${index}`]: filterOrigin[index][`warehouse_${index}`] === undefined ? filterOrigin[index-1][`warehouse_${index}`] : filterOrigin[index][`warehouse_${index}`] , 
              [`warehouse_${index + 1}`]: filterOrigin[index][`warehouse_${index + 1}`],
              driver_number: filterOrigin[index].driver_number,
              driver_name: filterOrigin[index].driver_name,
              vehicle: filterOrigin[index].vehicle,
              number_of_package: filterOrigin[index].number_of_package,
              actual_time_departed: filterOrigin[index].actual_time_departed ? filterOrigin[index].actual_time_departed : '',
              actual_time_arrival: filterOrigin[index].actual_time_arrival ? filterOrigin[index].actual_time_arrival : '',
              status: "",
              ...transport,
              total_package: (booking?.booking?.contract?.cargoList || []).reduce(
                (sum, cargo) => sum + (+cargo.numPackages || 0),
                0
              ),
            })
          }
        })
        console.log("check arr------------", arr)
        setOrgin(arr)
        setOriginDateSelectorForLTL(Date)
    }else{
      let l = [];
      for (let i = 0; i < origin.length; i++) {
        if (i != id) {
          l.push(origin[i]);
        }
      }
      setOrgin(l);
    }
    let err = [];
    for (let i = 0; i < originError.length; i++) {
      if (i != id) {
        err.push(originError[i]);
      }
    }
    setOriginError([...err]);
  };

  const del2 = (id, key) => {
    if(key === 'deleteWarehouse'){
      setDestinationWarehouses((prevWarehouses) =>
        prevWarehouses
          .filter((_, i) => i !== id)
          .map((_, i) => `Warehouse ${i + 1}`)
      );
      let b = booking?.booking
      let destination_origin = ""
      if(b?.contract?.finalPlaceOfDelivery.trim().length==0){
          destination_origin = b?.contract?.portOfDischarge
      }else{
          destination_origin = b?.contract?.finalPlaceOfDelivery
      }
        let d = {
        origin: destination_origin,
        destination: booking.destination,
        driver_number: "",
        driver_name: "",
        vehicle: "",
        number_of_package: "",
        status: "",
        transport_ref_number: "",
        transport_name: "",
        total_package: booking?.booking?.contract?.cargoList?.reduce((sum, cargo) => sum + (+cargo.numPackages), 0),
      }
      
      let arr = [];
      let Date = [];
      let cloneDate = [...destinationDateSelectorForLTL]
      let cloneDestination = [...des]
      let filterDate = cloneDate.filter((_, i) => i !== id)
      let filterDestination = cloneDestination.filter((_, i) => i !== id)
      filterDate.forEach((_, index, array) => {
        if(index === 0){
          if(array.length === 1){
            Date.push(st === 'LCL' ? destination_delivery_LCL : destination_delivery_AIR)
          }else{
            Date.push(st === 'LCL' ? destinationDateSelector_Index_For_LCL : destinationDateSelector_Index_For_LCL)
          }   
        }else if((index+1) === array.length && array.length > 0){
          Date.push(destinationDateSelector_LastIndex)
        }else{
          Date.push({
            actual_time_departed: `ATD @ Warehouse ${index}`,
            actual_time_arrival: `ATA @ Warehouse ${index}`,
          })
        }
      })
      filterDestination.forEach((_, index, array) => {
        console.log("filterDestination==========", filterDestination)
        let tempDateSelector = st === 'LCL' ? 
        { 
          loaded_cfs: filterDestination[index].loaded_cfs ? filterDestination[index].loaded_cfs : '',
          atdfrompod: filterDestination[index].atdfrompod ? filterDestination[index].atdfrompod : ''
        } 
        : st === 'Air' ? 
        {
          arrival_dispatch_airport: filterDestination[index].arrival_dispatch_airport ? filterDestination[index].arrival_dispatch_airport : ''
        } : {};
        let transport = booking?.fpod?.startsWith("US") ? 
          { transport_ref_number: filterDestination[index].transport_ref_number, transport_name: filterDestination[index].transport_name } : {};
        if(index === 0){
          let temp = array.length === 1 ? {estimate_delivery_date_to_consignee: "", actual_delivery_date: ""} 
          : {actual_time_arrival_at_warehouse: ''}
          arr.push({ 
            origin: IMPORT_BOOKING ? filterDestination[0].origin : destination_origin,
            terminal_cfs: destination_origin,
            [array.length === 1 ? 'destination' :`warehouse_1`]: array.length === 1 ? booking.destination : filterDestination[index].warehouse_1,
            driver_number: filterDestination[index].driver_number,
            driver_name: filterDestination[index].driver_name,
            vehicle: filterDestination[index].vehicle,
            number_of_package: filterDestination[index].number_of_package,
            status: "",
            total_package: booking?.booking?.contract?.cargoList?.reduce((sum, cargo) => sum + (+cargo.numPackages), 0),
            loaded_cfs: filterDestination[index].loaded_cfs ? filterDestination[index].loaded_cfs : '',
            atdfrompod: filterDestination[index].atdfrompod ? filterDestination[index].atdfrompod : '',
            ...temp,
            ...transport,
            ...tempDateSelector
          })
        }else if((index+1) === array.length && array.length > 1){
          arr.push({
            [`warehouse_${index}`]: filterDestination[index][`warehouse_${index}`] === undefined ? filterDestination[index-1][`warehouse_${index}`]: filterDestination[index][`warehouse_${index}`],
            destination: booking.destination,
            driver_number: filterDestination[index].driver_number,
            driver_name: filterDestination[index].driver_name,
            vehicle: filterDestination[index].vehicle,
            number_of_package: filterDestination[index].number_of_package,
            status: "",
            ...transport,
            total_package: booking?.booking?.contract?.cargoList?.reduce((sum, cargo) => sum + (+cargo.numPackages), 0),
            estimate_delivery_date_to_consignee: filterDestination[index].estimate_delivery_date_to_consignee ? filterDestination[index].estimate_delivery_date_to_consignee : '',
            actual_delivery_date: filterDestination[index].actual_delivery_date ? filterDestination[index].actual_delivery_date : '',
          })
        }else{
          arr.push({
            [`warehouse_${index}`]: filterDestination[index][`warehouse_${index}`] === undefined ? filterDestination[index-1][`warehouse_${index}`] : filterDestination[index][`warehouse_${index}`] , 
            [`warehouse_${index + 1}`]: filterDestination[index][`warehouse_${index + 1}`],
            driver_number: filterDestination[index].driver_number,
            driver_name: filterDestination[index].driver_name,
            vehicle: filterDestination[index].vehicle,
            number_of_package: filterDestination[index].number_of_package,
            status: "",
            ...transport,
            total_package: booking?.booking?.contract?.cargoList?.reduce((sum, cargo) => sum + (+cargo.numPackages), 0),
            actual_time_departed: filterDestination[index].actual_time_departed ? filterDestination[index].actual_time_departed : '',
            actual_time_arrival: filterDestination[index].actual_time_arrival ? filterDestination[index].actual_time_arrival : '',
          })
        }
      })
      setDes(arr)
      setDestinationDateSelectorForLTL(Date)
    }else{
      let l = [];
      for (let i = 0; i < des.length; i++) {
        if (i != id) {
          l.push(des[i]);
        }
      }
      setDes(l);
    }
    let err = [];
      for (let i = 0; i < destinationError.length; i++) {
        if (i != id) {
          err.push(destinationError[i]);
        }
      }
    setDestinationError([...err]);
  };

  const add2 = (e, key) => {
    e.preventDefault()
    let b = booking?.booking
    let destination_origin = ""
    if(b?.contract?.finalPlaceOfDelivery.trim().length==0){
        destination_origin = b?.contract?.portOfDischarge
    }else{
        destination_origin = b?.contract?.finalPlaceOfDelivery
    }
    let temp = IMPORT_BOOKING ? {terminal_cfs: destination_origin} : {}
    let d = {
      origin: IMPORT_BOOKING ? '' : destination_origin,
      destination: booking.destination,
      driver_number: "",
      driver_name: "",
      vehicle: "",
      number_of_package: "",
      status: "",
      ...temp,
      total_package: booking?.booking?.contract?.cargoList?.reduce((sum, cargo) => sum + (+cargo.numPackages), 0),
    }
    if(key === 'addWareHouses'){ 
      const newWarehouse = `Warehouse ${destinationWarehouses.length + 1}`;
      setDestinationWarehouses([...destinationWarehouses, newWarehouse]);
      let cloneDestination = [...des]
      let upadateDestinationWH = [];
      let destinationDateSelectorArray = [st === 'LCL' ? destinationDateSelector_Index_For_LCL : destinationDateSelector_Index_For_Air];
      let tempDateSelector = st === 'LCL' ? 
      { 
        loaded_cfs: cloneDestination[0].loaded_cfs ? cloneDestination[0].loaded_cfs : '',
        atdfrompod: cloneDestination[0].atdfrompod ? cloneDestination[0].atdfrompod : ''
      } 
      : st === 'Air' ? 
      {
        arrival_dispatch_airport: cloneDestination[0].arrival_dispatch_airport ? cloneDestination[0].arrival_dispatch_airport : ''
      } : {};
      let transportForInitial = LCL_IMPORT_TRANSPORT || AIR_IMPORT_TRANSPORT ? 
      { transport_ref_number: cloneDestination[0].transport_ref_number, transport_name: cloneDestination[0].transport_name } : {};
      upadateDestinationWH.push({
        origin: IMPORT_BOOKING ? cloneDestination[0].origin : destination_origin,
        warehouse_1: cloneDestination[0].warehouse_1 === undefined ? '' : cloneDestination[0].warehouse_1,
        driver_number: cloneDestination[0].driver_number,
        driver_name: cloneDestination[0].driver_name,
        vehicle: cloneDestination[0].vehicle,
        number_of_package: cloneDestination[0].number_of_package,
        status: "",
        actual_time_arrival_at_warehouse: cloneDestination[0].actual_time_arrival_at_warehouse ? cloneDestination[0].actual_time_arrival_at_warehouse : '', 
        total_package: booking?.booking?.contract?.cargoList?.reduce((sum, cargo) => sum + (+cargo.numPackages), 0),
        ...temp,
        ...tempDateSelector,
        ...transportForInitial
      });
      
      des.forEach((_, index, arr) => {
        let isLast = index + 1 === arr.length;
        let transport = (LCL_IMPORT_TRANSPORT || AIR_IMPORT_TRANSPORT) ? arr.length > 1 ? index+1 === arr.length ? {transport_ref_number: '', transport_name: ''} :
        { transport_ref_number: cloneDestination[index+1].transport_ref_number, transport_name: cloneDestination[index+1].transport_name } 
        : { transport_ref_number: '', transport_name: '' } : {}
        let destinationDateSelector = isLast
          ? {
              [`warehouse_${arr.length}`]: '',
              destination: booking.destination,
              driver_number: "",
              driver_name: "",
              vehicle: "",
              number_of_package: cloneDestination[0].number_of_package,
              status: "",
              estimate_delivery_date_to_consignee: "",
              actual_delivery_date: "",
              ...transport,
              total_package: booking?.booking?.contract?.cargoList?.reduce((sum, cargo) => sum + (+cargo.numPackages), 0)
            }
          : { 
              [`warehouse_${index + 1}`]: cloneDestination[index+1][`warehouse_${index + 1}`],
              [`warehouse_${index + 2}`]: cloneDestination[index+1][`warehouse_${index + 2}`],
              driver_number: cloneDestination[index+1].driver_number,
              driver_name: cloneDestination[index+1].driver_name,
              vehicle: cloneDestination[index+1].vehicle,
              number_of_package: cloneDestination[0].number_of_package,
              status: cloneDestination[index+1].status,
              actual_time_departed: cloneDestination[index+1].actual_time_departed ? cloneDestination[index+1].actual_time_departed : '',
              actual_time_arrival: cloneDestination[index+1].actual_time_arrival ? cloneDestination[index+1].actual_time_arrival : '',
              ...transport,
              total_package: booking?.booking?.contract?.cargoList?.reduce((sum, cargo) => sum + (+cargo.numPackages), 0)
            };
        let destinationDateSelectorArr = isLast
        ? destinationDateSelector_LastIndex
        : {
          actual_time_departed: `ATD @ Warehouse ${index + 1}`,
          actual_time_arrival: `ATA @ Warehouse ${index + 2}`,
          };
      
        upadateDestinationWH.push(destinationDateSelector);
        destinationDateSelectorArray.push(destinationDateSelectorArr);
      });
      setDes(upadateDestinationWH)
      setDestinationDateSelectorForLTL(destinationDateSelectorArray)
      setDestinationError([...destinationError, VEHICLE_ROW_ERROR_DEFAULT]);
    }else{
      
      if(des && des.length > 0){
        let updateDestination = {
          ...d,
          ...Object.keys(destinationDateSelector).reduce((ele, key) => {
            ele[key] = "";
            return ele;
          }, {}),
        };
        setDestinationError([...destinationError, VEHICLE_ROW_ERROR_DEFAULT]);
        setDes([...des, updateDestination]);
      }
    }
    
    
  }
  
  const addMultiDestination = (destinationIndex, key) => {
    let b = booking?.booking
    let destination_origin = ""
    if(b?.contract?.finalPlaceOfDelivery.trim().length==0)  { 
        destination_origin = b?.contract?.portOfDischarge
    }else{
        destination_origin = b?.contract?.finalPlaceOfDelivery
    }
    let cloneMultipleDes = [...multipleDes]
    let terminal = IMPORT_BOOKING ? {terminal_cfs: destination_origin} : {};
    let multipleDestination = {
      origin: IMPORT_BOOKING ? '' : destination_origin,
      destination: cloneMultipleDes[destinationIndex][0].destination,
      driver_number: "",
      driver_name: "",
      vehicle: "",
      number_of_package: "",
      status: "",
      ...terminal,
      total_package: cloneMultipleDes[destinationIndex][0].total_package,
    };
    if(key === 'addWareHouses'){
      console.log("destinationWarehouses", destinationWarehouses, destinationWarehouses === null) 
      if(destinationWarehouses.length === 0){
        let temp = new Array();
        multidest.forEach((_, index) => {
          index === destinationIndex ? temp.push([`Warehouse 1`]) : temp.push([])
        })
        setDestinationWarehouses(temp)
      }else{
        setDestinationWarehouses(prevState => {
          const newDestinationUpdate = [...prevState];
          newDestinationUpdate[destinationIndex] = [
            ...newDestinationUpdate[destinationIndex], 
            `Warehouse ${newDestinationUpdate[destinationIndex].length + 1}`
          ];
        
          return newDestinationUpdate;
        });
      }
      
      
      let temp = [];
      let tempDate = [];
      let destinationDateSelectorArray = [st === 'LCL' ? destinationDateSelector_Index_For_LCL : destinationDateSelector_Index_For_Air];
      cloneMultipleDes.forEach((ele, index, array) => {
        if(destinationIndex === index){
          let upadateDestinationWH = [];
          
          let tempDateSelector = st === 'LCL' ? {atdfrompod: ''} : st === 'Air' ? {arrival_dispatch_airport: ''} : {};
          let transportForInitial = LCL_IMPORT_TRANSPORT || AIR_IMPORT_TRANSPORT ? 
          { transport_ref_number: ele[0].transport_ref_number, transport_name: ele[0].transport_name } : {};
          upadateDestinationWH.push({
            origin: IMPORT_BOOKING ? ele[0].origin : destination_origin,
            warehouse_1: ele[0].warehouse_1 === undefined ? '' : ele[0].warehouse_1,
            // origin: IMPORT_BOOKING ? '' : destination_origin,
            // warehouse_1: '',
            driver_number: ele[0].driver_number,
            driver_name: ele[0].driver_name,
            vehicle: ele[0].vehicle,
            number_of_package: ele[0].number_of_package,
            status: "",
            total_package: cloneMultipleDes[destinationIndex][0].total_package,
            loaded_cfs: ele[0].loaded_cfs ? ele[0].loaded_cfs : '',
            actual_time_arrival_at_warehouse: ele[0].actual_time_arrival_at_warehouse ? ele[0].actual_time_arrival_at_warehouse : '',
            ...terminal,
            ...tempDateSelector,
            ...transportForInitial
          });
          ele.forEach((element, index, arr) => {
            let isLast = index + 1 === arr.length;
            let transport = (LCL_IMPORT_TRANSPORT || AIR_IMPORT_TRANSPORT) ? arr.length > 1 ? index+1 === arr.length ? {transport_ref_number: '', transport_name: ''} :
            { transport_ref_number: ele[index+1].transport_ref_number, transport_name: ele[index+1].transport_name } 
            : { transport_ref_number: '', transport_name: '' } : {}
            let destinationDateSelector = isLast
              ? {
                [`warehouse_${arr.length}`]: '',
                destination: booking.destination,
                driver_number: "",
                driver_name: "",
                vehicle: "",
                number_of_package: ele[0].number_of_package,
                status: "",
                ...transport,
                total_package: cloneMultipleDes[destinationIndex][0].total_package,
                estimate_delivery_date_to_consignee: "", 
                actual_delivery_date: "" 
              }
              : {
                [`warehouse_${index + 1}`]: ele[index+1][`warehouse_${index + 1}`],
                [`warehouse_${index + 2}`]: ele[index+1][`warehouse_${index + 2}`],
                driver_number: ele[index+1].driver_number,
                driver_name: ele[index+1].driver_name,
                vehicle: ele[index+1].vehicle,
                number_of_package: ele[0].number_of_package,
                status: "",
                ...transport,
                total_package: cloneMultipleDes[destinationIndex][0].total_package,
                actual_time_departed: ele[index+1].actual_time_departed ? ele[index+1].actual_time_departed : '',
                actual_time_arrival: ele[index+1].actual_time_arrival ? ele[index+1].actual_time_arrival : '',
                };
            let destinationDateSelectorArr = isLast
            ? destinationDateSelector_LastIndex
            : {
              actual_time_departed: `ATD @ Warehouse ${index + 1}`,
              actual_time_arrival: `ATA @ Warehouse ${index + 2}`,
              };
          
            upadateDestinationWH.push(destinationDateSelector);
            destinationDateSelectorArray.push(destinationDateSelectorArr);
          });
          console.log("upadateDestinationWH", temp, upadateDestinationWH)
          console.log("destinationDateSelectorArray", destinationDateSelectorArray)
          temp.push(upadateDestinationWH);
          tempDate.push(destinationDateSelectorArray);
        }else{
          temp.push(ele);
          console.log("ele--------->", tempDate, destinationDateSelectorForLTL[index])
          tempDate.push(destinationDateSelectorForLTL[index]?.length > 0 ? 
            destinationDateSelectorForLTL[index] : destinationDateSelectorArray
          );
          console.log("ele---------> tempDate", tempDate)
        }
        
      })
      let validation = [...multidestError];
      validation[destinationIndex].push(VEHICLE_ROW_ERROR_DEFAULT)
      setMultiDestError(validation);
      console.log("temp----------", temp)
      console.log("tempDate----------", tempDate)
      setMultipleDes(temp)
      setDestinationDateSelectorForLTL(tempDate)
    }else{
      let multiDestination = {
        ...multipleDestination,
        ...Object.keys(destinationDateSelector).reduce((selector, key) => {
          selector[key] = "";
          return selector;
        }, {}),
      };
     
      setMultipleDes((prevMultipleDes) => {
        return prevMultipleDes.map((subArray, index) => {
          if (index === destinationIndex) {
            return [...subArray, multiDestination];
          }
          return subArray;
        });
      });
      let validation = [...multidestError];
      validation[destinationIndex].push(VEHICLE_ROW_ERROR_DEFAULT)
      setMultiDestError(validation);
    }
  }

  const removeMultiDestination = (destinationArray, index, key) => {
    let updatedDestination = [...multipleDes]
    if(key === 'addWareHouses'){
      updatedDestination[destinationArray] = updatedDestination[destinationArray].filter((_, i) => i !== index);
      let warehouse = new Array();
      updatedDestination.forEach((ele, index) => {
        let temp = new Array();
        if(ele.length > 1){
          ele.forEach((e, i) => i !== 0 ? temp.push(`warehouse ${i}`) : null)
          warehouse.push(temp);
        }else{
          warehouse.push([]);
        }
      })
      setDestinationWarehouses(warehouse);

      let b = booking?.booking
      let destination_origin = ""
      if(b?.contract?.finalPlaceOfDelivery.trim().length==0){
          destination_origin = b?.contract?.portOfDischarge
      }else{
          destination_origin = b?.contract?.finalPlaceOfDelivery
      }
        let d = {
        origin: destination_origin,
        destination: booking.destination,
        driver_number: "",
        driver_name: "",
        vehicle: "",
        number_of_package: "",
        status: "",
        transport_ref_number: "",
        transport_name: "",
        total_package: booking?.booking?.contract?.cargoList?.reduce((sum, cargo) => sum + (+cargo.numPackages), 0),
      }

      let multipleDestination = new Array();
      let tempDateArray = new Array();
      updatedDestination.forEach((ele, index) => {
        let arrList = new Array();
        let DateList = new Array();
        ele.forEach((_, i, array) => {
          if(i === 0){
            if(array.length === 1){
              DateList.push(st === 'LCL' ? destination_delivery_LCL : destination_delivery_AIR)
            }else{
              DateList.push(st === 'LCL' ? destinationDateSelector_Index_For_LCL : destinationDateSelector_Index_For_LCL)
            }   
          }else if((i+1) === array.length && array.length > 0){
            DateList.push(destinationDateSelector_LastIndex)
          }else{
            DateList.push({
              actual_time_departed: `ATD @ Warehouse ${i}`,
              actual_time_arrival: `ATA @ Warehouse ${i+1}`,
            })
          }
        })

        ele.forEach((element, indexArr, array) => {
          let transport = booking?.fpod?.startsWith("US") ? 
            { transport_ref_number: ele[indexArr].transport_ref_number, transport_name: ele[indexArr].transport_name } : {};
          if(indexArr === 0){
            let temp = array.length === 1 ? 
            {estimate_delivery_date_to_consignee: ele[indexArr].estimate_delivery_date_to_consignee ? ele[indexArr].estimate_delivery_date_to_consignee : '', 
              actual_delivery_date: ele[indexArr].actual_delivery_date ? ele[indexArr].actual_delivery_date : ''} 
            : {actual_time_arrival_at_warehouse: ''}
            console.log("ele[indexArr]", ele[indexArr])
            arrList.push({ 
              origin: IMPORT_BOOKING ? ele[indexArr].origin : destination_origin,
              terminal_cfs: destination_origin,
              [array.length === 1 ? 'destination' : 'warehouse_1']: array.length === 1 ? destination_origin : ele[indexArr]['warehouse_1'],
              driver_number: ele[indexArr].driver_number,
              driver_name: ele[indexArr].driver_name,
              vehicle: ele[indexArr].vehicle,
              number_of_package: ele[indexArr].number_of_package,
              status: "",
              total_package: booking?.booking?.contract?.cargoList?.reduce((sum, cargo) => sum + (+cargo.numPackages), 0),
              loaded_cfs: ele[indexArr].loaded_cfs ? ele[indexArr].loaded_cfs : '',
              atdfrompod: ele[indexArr]?.atdfrompod ? ele[indexArr].atdfrompod : '',
              ...temp,
              ...transport,
              ...tempDateArray
            })
            }else if((indexArr+1) === array.length && array.length > 1){
              arrList.push({
                [`warehouse_${array.length}`]: ele[indexArr][`warehouse_${indexArr}`] === undefined ? ele[indexArr-1][`warehouse_${indexArr}`]: ele[indexArr][`warehouse_${indexArr}`],
                destination: booking.destination,
                driver_number: ele[indexArr].driver_number,
                driver_name: ele[indexArr].driver_name,
                vehicle: ele[indexArr].vehicle,
                number_of_package: ele[indexArr].number_of_package,
                status: "",
                ...transport,
                total_package: booking?.booking?.contract?.cargoList?.reduce((sum, cargo) => sum + (+cargo.numPackages), 0),
                estimate_delivery_date_to_consignee: ele[indexArr].estimate_delivery_date_to_consignee ? ele[indexArr].estimate_delivery_date_to_consignee : '',
                actual_delivery_date: ele[indexArr].actual_delivery_date ? ele[indexArr].actual_delivery_date : '',
              })
            }else{
              console.log("indexArr===========>", ele)
              arrList.push({
                [`warehouse_${indexArr}`]: ele[indexArr][`warehouse_${indexArr}`] === undefined ? ele[indexArr-1][`warehouse_${indexArr}`] : ele[indexArr][`warehouse_${indexArr}`] ,
                [`warehouse_${indexArr+1}`]: ele[indexArr][`warehouse_${indexArr + 1}`],
                driver_number: ele[indexArr].driver_number,
                driver_name: ele[indexArr].driver_name,
                vehicle: ele[indexArr].vehicle,
                number_of_package: ele[indexArr].number_of_package,
                status: "",
                ...transport,
                total_package: booking?.booking?.contract?.cargoList?.reduce((sum, cargo) => sum + (+cargo.numPackages), 0),
                actual_time_departed: ele[indexArr].actual_time_departed ? ele[indexArr].actual_time_departed : '',
                actual_time_arrival: ele[indexArr].actual_time_arrival ? ele[indexArr].actual_time_arrival : '',
              })
          }
        })
        multipleDestination.push(arrList)
        tempDateArray.push(DateList)
      })
      setMultipleDes(multipleDestination)
      setDestinationDateSelectorForLTL(tempDateArray)
    }else{
      updatedDestination[destinationArray] = updatedDestination[destinationArray].filter((_, i) => i !== index);
      setMultipleDes(updatedDestination);
    }
    let validation = [...multidestError]
    validation[destinationArray] = validation[destinationArray].filter((_, i) => i !== index);
    setMultiDestError(validation);
  }

  let formRows;
  if (EXPORT_BOOKING) {
    formRows = origin;
  }
  if ((IMPORT_BOOKING && multidest?.length === 1) ||
  IMPORT_BOOKING && multidest === undefined) {
    formRows = des;
  }
  if (IMPORT_BOOKING && multidest?.length > 1) {
    formRows = multipleDes;
  }

  

  // const checkValidationForLTL = (route, key) =>{
  //   let formRows = route;
  //   let driverNumber = [];
  //     if(key === "origin"){
  //       origin.map((ele) => driverNumber.push(ele.driver_number))
  //     }
  //     if(key === "des"){
  //       des.map((ele) => driverNumber.push(ele.driver_number))
  //     }
  //     let uniquePhNumber = new Set(driverNumber);
  //     function checValidNumber(phNumber){
  //       if(key === "origin"){
  //         if(EXPORT_BOOKING){
  //           return phNumber.length === 10;
  //         }else{
  //           return phNumber.length >= 7 && phNumber.length <= 15;
  //         }
  //       }
  //       if(key === "des"){
  //         if(IMPORT_BOOKING){
  //           return phNumber.length === 10;
  //         }else{
  //           return phNumber.length >= 7 && phNumber?.length <= 15;
  //         }
  //       }
  //     }
  //     let errorArr = formRows.map((obj, index, objArr) => {
  //       let errorState = {};
      
  //       if (index === 0) {
  //         errorState = {
  //           origin: obj.origin !== "",
  //           [objArr.length > 1 ? 'warehouse_1' : 'destination']: obj[objArr.length > 1 ? 'warehouse_1' : 'destination'] !== "",
  //           driver_number: checValidNumber(obj.driver_number),
  //           vehicle: obj.vehicle !== "" && obj.vehicle.length <= 20,
  //           number_of_package: (+obj.number_of_package) === (+obj.total_package),
  //         };
  //       }
  //       else if (index + 1 === objArr.length && objArr.length > 1) {
  //         errorState = {
  //           [`warehouse_${index}`]: obj[`warehouse_${index}`] !== "",
  //           destination: obj.destination !== "",
  //           driver_number: checValidNumber(obj.driver_number),
  //           vehicle: obj.vehicle !== "" && obj.vehicle.length <= 20,
  //         };
  //       } 
  //       else {
  //         errorState = {
  //           [`warehouse_${index}`]: obj[`warehouse_${index}`] !== "",
  //           [`warehouse_${index+1}`]: obj[`warehouse_${index+1}`] !== "",
  //           driver_number: checValidNumber(obj.driver_number),
  //           vehicle: obj.vehicle !== "" && obj.vehicle.length <= 20,
  //         };
  //       }
      
  //       return errorState;
  //     });
      
  //     console.log("errorArr------>",errorArr);
      
      
  //     if(key === "origin"){
  //       setOriginError(errorArr)
  //     }
  //     if(key === "des"){
  //       setDestinationError(errorArr)
  //     } 
  //     return formRows.length > 0 && errorArr.every(obj => 
  //       Object.values(obj).every(value => value === true)
  //     );
  // }

  const checkValidation = (route, key, transportType) =>{
    let formRows = route;
    let driverNumber = [];
      if(key === "origin"){
        origin.map((ele) => ele.driver_number !== '' ? driverNumber.push(ele.driver_number) : null)
      }
      if(key === "des"){
        des.map((ele) => ele.driver_number !== '' ? driverNumber.push(ele.driver_number) : null)
      }
      let uniquePhNumber = new Set(driverNumber);
      function checValidNumber(phNumber){
        if(key === "origin"){
          if(EXPORT_BOOKING){
            return phNumber.length === 10;
          }else{
            return phNumber.length >= 7 && phNumber.length <= 15;
          }
        }
        if(key === "des"){
          if(IMPORT_BOOKING){
            return phNumber.length === 10;
          }else{
            return phNumber.length >= 7 && phNumber?.length <= 15;
          }
        }
      }
      let errorArr;
      
      if(key === "des" && (booking.shipmentType === SHIPMENT_TYPE.fcl_cfs_cfs || booking.shipmentType === SHIPMENT_TYPE.fcl_f_cfs)){
        let regex = /^[A-Z]{1,4}[0-9]{1,7}/;
        errorArr = formRows.map(obj => ({
          container_number_vehicle: obj.container_number_vehicle !== "" && regex.test(obj.container_number_vehicle) && obj.container_number_vehicle.length === 11,
          origin: obj.origin !== "",
          destination: obj.destination !== "",
          driver_number: checValidNumber(obj.driver_number) && driverNumber.length === uniquePhNumber.size,
          vehicle: obj.vehicle !== "" && obj.vehicle.length <= 20,
          number_of_package: (+formRows.reduce((sum, obj) => {
            return sum + (parseInt(obj.number_of_package) || 0);
          }, 0)) <= (+obj.total_package)
        }))
      }else {
        errorArr = formRows.map((obj, index, formArr) => ({
          [transportType === 'LTL' ? index === 0 ? 'origin' : `warehouse_${index}` : 'origin']: obj[transportType === 'LTL' ? index === 0 ? 'origin' : `warehouse_${index}` : 'origin'] !== "",
          [transportType === 'LTL' ? (index+1) === formArr.length ? 'destination' : `warehouse_${index+1}` : 'destination']: obj[transportType === 'LTL' ? (index+1) === formArr.length ? 'destination' : `warehouse_${index+1}` : 'destination'] !== "",
          driver_number: booking.shipmentType === LCL_OR_AIR ? obj.driver_number !== "" ? 
          transportType === 'FTL' ? checValidNumber(obj.driver_number) && driverNumber.length === uniquePhNumber.size : checValidNumber(obj.driver_number) : true : // FOR LCL
          transportType === 'FTL' ? checValidNumber(obj.driver_number) && driverNumber.length === uniquePhNumber.size : checValidNumber(obj.driver_number), // FOR AIR
          vehicle: booking.shipmentType === LCL_OR_AIR ? obj.vehicle.length <= 20 : obj.vehicle !== ""  && obj.vehicle.length <= 20,
          number_of_package: transportType === 'LTL' ? index === 0 && obj.number_of_package !== '' ? (+obj.number_of_package) === (+obj.total_package) : true : (+formRows.reduce((sum, obj) => {
            return sum + (parseInt(obj.number_of_package) || 0);
          }, 0)) <= (+obj.total_package)
        }))
      }
      if(key === "origin"){
        setOriginError(errorArr)
      }
      if(key === "des"){
        
        setDestinationError(errorArr)
      } 
      return formRows.length > 0 && errorArr.every(obj => 
        Object.values(obj).every(value => value === true)
      );
  }

  function checkMultiDestinationValid() {
    if (multidest?.length > 1) {
      let driverNumber = [];
      multipleDes.map((row) => row.map((ele) => ele.driver_number !== '' ? driverNumber.push(ele.driver_number) : null ));
      let uniquePhNumber = new Set(driverNumber);
      const regex = /^[A-Z]{1,4}[0-9]{1,7}$/;
      function checValidNumber(phNumber){
        if(IMPORT_BOOKING){
          return phNumber.length === 10;
        }else{
          return phNumber.length >= 7 && phNumber?.length <= 15;
        }
      }
      const mapInnerArray = (innerArray, includeContainer) => {
        return innerArray.map((obj, index, formArr) => {
          const baseValidation = {
            [transportTypeDestination === 'LTL' ? index === 0 ? 'origin' : `warehouse_${index}` : 'origin']: obj[transportTypeDestination === 'LTL' ? index === 0 ? 'origin' : `warehouse_${index}` : 'origin'] !== "",
            [transportTypeDestination === 'LTL' ? (index+1) === formArr.length ? 'destination' : `warehouse_${index+1}` : 'destination']: obj[transportTypeDestination === 'LTL' ? (index+1) === formArr.length ? 'destination' : `warehouse_${index+1}` : 'destination'] !== "",
            driver_number: booking.shipmentType === SHIPMENT_TYPE.lcl ? obj.driver_number !== "" ? 
            transportTypeDestination === 'FTL' ? checValidNumber(obj.driver_number) && driverNumber.length === uniquePhNumber.size : checValidNumber(obj.driver_number) : true : // FOR LCL
            transportTypeDestination === 'FTL' ? checValidNumber(obj.driver_number) && driverNumber.length === uniquePhNumber.size : checValidNumber(obj.driver_number), // FOR AIR
            vehicle: booking.shipmentType === SHIPMENT_TYPE.lcl ? obj.vehicle.length <= 20 :  obj.vehicle !== "" && obj.vehicle.length <= 20,
            number_of_package: transportTypeDestination === 'LTL' ? index === 0 && obj.number_of_package !== '' ? (+obj.number_of_package) === (+obj.total_package) : true :
              innerArray.reduce((sum, obj) => {
                return sum + (parseInt(obj.number_of_package) || 0);
              }, 0) <= +obj.total_package,
          };
  
          if (includeContainer) {
            return {
              ...baseValidation,
              container_number_vehicle:
                obj.container_number_vehicle !== "" &&
                regex.test(obj.container_number_vehicle) &&
                obj.container_number_vehicle.length === 11,
            };
          }
          return baseValidation;
        });
      };
  
      const includeContainer =
        booking.shipmentType === "FCL (Dock/Dock)" ||
        booking.shipmentType === "FCL (Factory/Dock)";
  
      const errorArr = multipleDes.map((innerArray, index) =>{
        if(innerArray.length === 1){
          return innerArray.every(obj => {
            return Object.keys(obj).every(key => {
              if (key === "origin" || key === "destination" || key === "total_package" || key === "terminal_cfs") {
                return true;
              }
              return obj[key] === "";
            });
          }) ? multidestError[index].map(obj =>
            Object.fromEntries(Object.keys(obj).map(key => [key, true]))
        ) : mapInnerArray(innerArray, includeContainer)
        }else{
          return mapInnerArray(innerArray, includeContainer)
        }
      });
      console.log("errorArr====================> multipleDes", multipleDes)
      console.log("errorArr====================>", errorArr)
      setMultiDestError(errorArr)
      return errorArr.every(innerArray =>
        innerArray.every(obj =>
          Object.values(obj).every(value => value === true)
        )
      );
    }
    return false;
  }

  const checkMultiDestinationValidForLTL = (nestedArray, key) => {
    function checValidNumber(phNumber){
      if(key === "des"){
        if(IMPORT_BOOKING){
          return phNumber.length === 10;
        }else{
          return phNumber.length >= 7 && phNumber?.length <= 15;
        }
      }
    }
    let error = nestedArray.map(innerArray =>
      innerArray.map((obj, index, objArr) => {
        let errorState = {};

        const isFirst = index === 0;
        const isLast = index === objArr.length - 1;
        const hasMultipleStops = objArr.length > 1;

        if (isFirst) {
          errorState = {
            origin: obj.origin?.trim() !== "",
            [hasMultipleStops ? 'warehouse_1' : 'destination']: obj[hasMultipleStops ? 'warehouse_1' : 'destination']?.trim() !== "",
            driver_number: checValidNumber(obj.driver_number),
            vehicle: obj.vehicle?.trim() !== "" && obj.vehicle?.length <= 20,
            number_of_package: (+obj.number_of_package) === (+obj.total_package),
          };
        } else if (isLast) {
          errorState = {
            [`warehouse_${index}`]: obj[`warehouse_${index}`]?.trim() !== "",
            destination: obj.destination?.trim() !== "",
            driver_number: checValidNumber(obj.driver_number),
            vehicle: obj.vehicle?.trim() !== "" && obj.vehicle?.length <= 20,
          };
        } else {
          errorState = {
            [`warehouse_${index}`]: obj[`warehouse_${index}`]?.trim() !== "",
            [`warehouse_${index + 1}`]: obj[`warehouse_${index + 1}`]?.trim() !== "",
            driver_number: checValidNumber(obj.driver_number),
            vehicle: obj.vehicle?.trim() !== "" && obj.vehicle?.length <= 20,
          };
        }

        return errorState;
      })
    );
    setMultiDestError(error)
    return error.every(innerArray =>
      innerArray.every(obj =>
        Object.values(obj).every(value => value === true)
      )
    );
  };

  const checkNumPackage = (route, key, transportType) => {
    let formRows = route;
    const errorArr = formRows.map((obj, index) => ({
      number_of_package: transportType === 'LTL' ? index === 0 && obj.number_of_package !== '' ? (+obj.number_of_package) === (+obj.total_package) : true : (+formRows.reduce((sum, obj) => {
        return sum + (parseInt(obj.number_of_package) || 0);
      }, 0)) <= (+obj.total_package)
    }));
    if (key === "origin") {
      setOriginError(errorArr);
    }
    if (key === "des") {
      setDestinationError(errorArr);
    }
    return formRows.length > 0 && errorArr.every(obj => obj.number_of_package === true);
  };

  function checkMultiDestinationNumpackage() {
    if (multidest?.length > 1) {
      const errorArr = multipleDes.map((innerArray) => {
        return innerArray.map((obj, index) => ({
          number_of_package: transportTypeDestination === 'LTL' ? index === 0 && obj.number_of_package !== '' ? (+obj.number_of_package) === (+obj.total_package) : true :
            innerArray.reduce((sum, obj) => {
              return sum + (parseInt(obj.number_of_package) || 0);
            }, 0) <= +obj.total_package,
        }));
      });
  
      setMultiDestError(errorArr);
  
      return errorArr.every((innerArray) =>
        innerArray.every((obj) => obj.number_of_package === true)
      );
    }
    return false;
  }

  function checkDestination(){
    let checkDestination;
    if(!IMPORT_BOOKING){
      checkDestination = checkNumPackage(des, "des", transportTypeDestination);
    }else{
      if(des.length === 1){
        checkDestination = des.every(obj => {
          return Object.keys(obj).every(key => {
            if (key === "origin" || key === "destination" || key === "total_package" || key === 'terminal_cfs') {
              return true;
            }
            console.log("key=========>", key, obj[key] === "")
            return obj[key] === "";
          });
        }) ? true : checkValidation(des, "des", transportTypeDestination)
      }else{
        checkDestination = checkValidation(des, "des", transportTypeDestination);
      }
    }
    return checkDestination;
  }

  function checkOrigin(){
    let checkOrigin;
    if(!EXPORT_BOOKING){
      checkOrigin = checkNumPackage(origin, "origin", transportTypeOrigin);
    }else{
      if(origin.length === 1){
        checkOrigin = origin.every(obj => {
          return Object.keys(obj).every(key => {
            if (key === "origin" || key === "destination" || key === "total_package" || key === 'terminal_cfs') {
              return true;
            }
            return obj[key] === "";
          });
        }) ? true : checkValidation(origin, "origin", transportTypeOrigin)
      }else{
        checkOrigin = checkValidation(origin, "origin", transportTypeOrigin);
      }
    }
    return checkOrigin;
  }

  // function checkOriginForLTL(){
  //   return checkValidationForLTL(origin, "origin");
  // }

  // function checkDestinationForLTL(){
  //   return checkValidationForLTL(origin, "origin");
  // }

  const onsave = () => {

    let isVehicleRowError;
    if(sc == SHIPMENT_SCOPE.d2d || sc == SHIPMENT_SCOPE.p2d){
      if(st == SHIPMENT_TYPE.fcl_cfs_f){
        if(origin.length > 0){
          isVehicleRowError = checkOrigin(); 
        }
      }
      if(st == SHIPMENT_TYPE.fcl_f_cfs){
        if(des.length > 0 || multipleDes.length > 0){
          let checkDes = checkDestination();
          let multipleDestination = !IMPORT_BOOKING
          ? checkMultiDestinationNumpackage() : checkMultiDestinationValid()
          isVehicleRowError = checkDes || multipleDestination;
        }
      }
      if(origin.length > 0 && des.length > 0){
        let checkOrg = checkOrigin();
        let checkDes = checkDestination();
        isVehicleRowError = checkOrg && checkDes;
      }
      if(origin.length > 0 && multipleDes.length > 0){
        let checkOrg = checkOrigin();
        let multipleDestination = !IMPORT_BOOKING ? checkMultiDestinationNumpackage() : checkMultiDestinationValid();
        console.log("checkOrg===========", checkOrg, multipleDestination)
        isVehicleRowError = checkOrg && multipleDestination;
      }
    }
    if(sc == SHIPMENT_SCOPE.d2p){
      if(origin.length > 0 || des.length > 0){
        let checkOrg = checkOrigin();
        let checkDes = checkDestination();
        isVehicleRowError = checkOrg || checkDes;
      }
    }
    if(sc == SHIPMENT_SCOPE.p2d){ 
      if(des.length > 0 || multipleDes.length > 0){
        let checkDes = checkDestination();
        let multipleDestination = !IMPORT_BOOKING ? checkMultiDestinationNumpackage() : checkMultiDestinationValid();
        isVehicleRowError = checkDes || multipleDestination;
      }
    }
    if (isVehicleRowError) {
      if (origin && origin.length > 0) {
        ret.vorgin = origin;
      } 
      if(des && des.length > 0){
        ret.vdes = des;
      }
      
      if ((multipleDes && multipleDes.length > 0)) {
        for (let i = 0; i < multipleDes.length; i++) {
          if(i==0){
            ret.vdes = multipleDes[i]
          }else{
            let l = i+1
            ret['vdes'+l] = multipleDes[i]
          }
        }
      }
      console.log("ret---------->", ret.vorgin)
      console.log("ret.vdes---------->", ret.vdes)
      console.log("ret---------->", ret)
      ret.transportTypeOrigin = ret?.vorgin?.length > 0 ? transportTypeOrigin : ''; 
      ret.transportTypeDestination = ret?.vdes?.length > 0 ? transportTypeDestination : '';
      ret.import_booking = IMPORT_BOOKING;
      ret.export_booking = EXPORT_BOOKING;
      myactionsstore.vModalVisible = false;
    } 
    else {
      configStore.setModalMessage("Please check all fields");
    }
  };

  const handleStopTracking = async (key, bookingId) => {
    loader.show();
    let transTypeOrigin
    if(transportTypeOrigin === 'LTL') transTypeOrigin = "FTL";
    if(transportTypeOrigin === 'FTL') transTypeOrigin = "LTL";
    const result = Api.stopTracking({key, bookingId, transTypeOrigin})
    loader.hide();
    if(clearType === 'origin'){
      delete configStore.modalvisibledata.vorgin
      setOrgin([])
      setOriginWarehouses([])
      setOriginDateSelectorForLTL([])
      setOriginOrder(true)
      if(transportTypeOrigin === 'LTL') setTransportTypeOrigin("FTL");
      if(transportTypeOrigin === 'FTL') setTransportTypeOrigin("LTL");
    }
    if(clearType === 'destination'){
      delete configStore.modalvisibledata.vdes
      setDes([])
      setDestinationWarehouses([])
      setDestinationDateSelectorForLTL([])
      setDestinationOrder(true)
      if(transportTypeDestination === 'LTL') setTransportTypeDestination("FTL");
      if(transportTypeDestination === 'FTL') setTransportTypeDestination("LTL");
    }
    if(clearType === 'Multiple'){
      multidest.map((_, index) => index === 0 ? delete configStore.modalvisibledata.vdes 
      : delete configStore.modalvisibledata[`vdes${index+1}`] )
      setMultipleDes([])
      setDestinationWarehouses([])
      setDestinationDateSelectorForLTL([])
      setDestinationOrder(true)
      if(transportTypeDestination === 'LTL') setTransportTypeDestination("FTL");
      if(transportTypeDestination === 'FTL') setTransportTypeDestination("LTL");
    }
    setClearData(false)
    setClearType('')
  }

  function convertDateFormat(dateStr) {
    const dateFormatRegex = /^\d{4}-\d{2}-\d{2}$/;
    if (dateFormatRegex.test(dateStr)) {
        return dateStr;
    }
    if (!dateStr) return "";
    const [day, month, year] = dateStr.split("-");
    return `${year}-${month}-${day}`;
  }
  let modalClass = "modal";
  if (myactionsstore.vModalVisible) modalClass += " is-active";

  const updateOrigin = (index, key, value) => {
    if (key === "number_of_package" && (value <= 0 || /[-eE]/.test(value))) {
      value = "";
    }
    let updatedOrigin;
    console.log("updateOrigin", index, key, value, key.startsWith('warehouse'))
    if (transportTypeOrigin === 'LTL' && (key.startsWith('warehouse') || key === 'number_of_package')) {
      updatedOrigin = origin.map((item) => ({
        ...item,
        [key]: value
      }));
    } else {
      updatedOrigin = origin.map((item, idx) =>
        idx === index ? { ...item, [key]: value } : item
      );
    }
    setOrgin(updatedOrigin);
  };
  

  const updateDestination = (index, key, value) => {
    if (key === "number_of_package" && (value <= 0 || /[-eE]/.test(value))) {
      value = "";
    }
    let updatedDestination;
    if (transportTypeDestination === 'LTL' && (key.startsWith('warehouse') || key === 'number_of_package')) {
      updatedDestination = des.map((item) => ({
        ...item,
        [key]: value
      }));
    } else {
      updatedDestination = des.map((item, idx) =>
        idx === index ? { ...item, [key]: value } : item
      );
    }
    setDes(updatedDestination);
  };

  const updateMultiplDes = (outerIndex, innerIndex, key, value) => {
    if (key === "number_of_package" && (value <= 0 || /[-eE]/.test(value))) {
      value = "";
    }
    let updatedMultipleDes;

    if (transportTypeDestination === "LTL" && (key.startsWith('warehouse') || key === 'number_of_package')) {
      updatedMultipleDes = multipleDes.map((outerItem, oIdx) =>
        oIdx === outerIndex
          ? outerItem.map((item) => ({
              ...item,
              [key]: value
            }))
          : outerItem
      );
    } else {
      updatedMultipleDes = multipleDes.map((outerItem, oIdx) =>
        oIdx === outerIndex
          ? outerItem.map((item, iIdx) =>
              iIdx === innerIndex ? { ...item, [key]: value } : item
            )
          : outerItem
      );
    }
    setMultipleDes(updatedMultipleDes);
  };
  console.log("2409LCLCEN05710016 origin", origin, originError)
  console.log("2409LCLCEN05710016 des", des, destinationError)
  console.log("2409LCLCEN05710016 multipleDes", multipleDes, multidestError)
  console.log("2409LCLCEN05710016 originDisable", originDisable)  
  console.log("2409LCLCEN05710016 destinationDisable", destinationDisable)
  console.log("2409LCLCEN05710016 originDateSelector", originDateSelector)
  console.log("2409LCLCEN05710016 destinationDateSelector", destinationDateSelector)
  console.log("check", originDateSelectorForLTL)
  console.log("check destinationDateSelectorForLTL", destinationDateSelectorForLTL)
  console.log("2409LCLCEN05710016 destinationWarehouses", originWarehouses, destinationWarehouses)
  console.log("2409LCLCEN05710016 warehouses", transportTypeOrigin, transportTypeDestination)
  console.log("2409LCLCEN05710016 warehouses", booking.ltlversion)

  async function consentCall(driver_number, key, i){
    try {
      Api.consentStatus({
        driver_number: driver_number,
        bookingId: ret._id,
        key: key
      }, async (response) => {
        configStore.setModalMessage(`Consent is ${response.data}`)
        if (response.data === "ALLOWED") {
          setDes(prev =>
            prev.map((item, index) =>
              index === i ? { ...item, consent: "ALLOWED" } : item
            )
          );
          configStore.modalvisibledata = {
            ...configStore.modalvisibledata,
            vdes: configStore.modalvisibledata.vdes.map(item => ({
              ...item,
              consent: "ALLOWED"
            }))
          };
        }
      });

    } catch (error) {
      console.error("Consent update failed:", error);
      alert("Error occurred while calling the consent API.");
    }
  }

  return (
    <>
        
        <div className={modalClass}>
          <div className="modal-background"></div>
          <div
            className="modal-card"
            onClick={(e) => {
              e.stopPropagation();
            }}
            style={{ borderRadius: "10px", width: "95%" }}
          >
            <section className="modal-card-body">
              <div
                className="table-container"
                onClick={(e) => e.stopPropagation()}
              >
                {(sc == SHIPMENT_SCOPE.d2p || sc == SHIPMENT_SCOPE.d2d) &&
                st != SHIPMENT_TYPE.fcl_f_cfs && origin && origin.length > 0 ? (
                  <>
                    <div>
                      <div class="px-5 py-2 flex align-center justify-between">
                        <p class="text-base font-semibold">Origin Pick-up</p>
                        <div>
                          <div class="flex align-center">
                            <p class="text-base font-semibold">
                              Total No. of Packages: {(+origin[0].total_package)}
                            </p>
                          </div>
                        </div>
                        { ret.shipmentType === 'LCL' || ret.shipmentType === 'Air' ? 
                          <div class="flex items-center space-x-4">
                            <span class="font-bold">Transport Type:</span>
                            <label class="flex items-center space-x-2">
                                <input checked={transportTypeOrigin === "FTL"} type="radio" name="transportTypeOrigin" value="FTL"
                                  disabled={booking.ltlversion ? false : true}
                                  onChange={() => {
                                    console.log("booking?.vorgin?.length", booking?.vorgin?.length)
                                    if(booking?.vorgin?.length > 0){
                                      setClearData(true);
                                      setClearType('origin')
                                      setOriginDisable([])
                                    }else{
                                      setOrgin([])
                                      setOriginWarehouses([])
                                      setOriginDateSelectorForLTL([])
                                      setOriginDisable([])
                                      setOriginOrder(true)
                                      setTransportTypeOrigin("FTL");
                                    }
                                  }}
                                class="w-5 h-5 text-blue-600 border-gray-300 focus:ring-blue-500" />
                                <span>FTL</span>
                            </label>
                            <label class="flex items-center space-x-2">
                                <input checked={transportTypeOrigin === "LTL"} type="radio" name="transportTypeOrigin" value="LTL"
                                  disabled={booking.ltlversion ? false : true}
                                  onChange={() => {
                                      if(booking?.vorgin?.length > 0){
                                        setClearData(true)
                                        setClearType('origin')
                                        setOriginDisable([])
                                      }else{
                                        setOrgin([])
                                        setOriginWarehouses([])
                                        setOriginDisable([])
                                        setOriginDateSelectorForLTL([])
                                        setOriginOrder(true)
                                        setTransportTypeOrigin("LTL")
                                      }
                                    }
                                  }
                                  class="w-5 h-5 text-blue-600 border-gray-300 focus:ring-blue-500" />
                                <span>LTL</span>
                            </label>
                          </div> : <div></div>
                        }
                      </div>
                      {origin.map((e, i) => {
                        return (
                          <div
                            id={i + "0"}
                            key={i + "0"}
                            class="mb-5 p-5 bg-custom-gray rounded-md"
                          >
                            <div class="ml-4 flex align-center">
                                {e.consent === 'UNKNOWN' && <button class='p-3 bg-[#C9DEFF] border-0 rounded-md'>Driver Status: {`Invalid Driver Number`}</button>}
                                {((e.consent === 'PENDING') && e?.tripstatus !== 'completed') || (e.consent != undefined && e.consent.indexOf('This Driver Number is already assigned') != -1) ?
                                <>
                                <button class='p-3 bg-[#C9DEFF] border-0 rounded-md'> Driver Status: {e.consent}</button>
                                {e.consent === 'PENDING' && <button onClick={()=>{
                                  try {
                                    Api.consentStatus({
                                      driver_number: e.driver_number,
                                      tripId: e.tripId,
                                      bookingId: ret._id,
                                      key: 'vorgin'
                                    }, async (response) => {
                                      console.log("error response", response)
                                      configStore.setModalMessage(`Consent is ${response.data}`)
                                      if (response.data === "ALLOWED") {
                                        setOrgin(prev =>
                                          prev.map((item, index) =>
                                            index === i ? { ...item, consent: "ALLOWED" } : item
                                          )
                                        );
                                        configStore.modalvisibledata = {
                                          ...configStore.modalvisibledata,
                                          vorgin: configStore.modalvisibledata.vorgin.map(item => ({
                                            ...item,
                                            consent: "ALLOWED"
                                          }))
                                        };
                                      }
                                    });
                              
                                  } catch (error) {
                                    configStore.setModalMessage(error)
                                    console.error("Consent update failed:", error);
                                  }
                                  
                                }} class ='ml-2 p-2 bg-[#C9DEFF] p-1 border-0 rounded-md'><span className="icon"><i className="fas fa-refresh fas fa-lg"></i></span></button>}
                                </>:
                                <>
                                  { e.consent === 'ALLOWED' && <button class='p-3 bg-[#C9DEFF] border-0 rounded-md'> Trip Status: {e.tripstatus}</button>} 
                                </>}
                              </div>
                            <div class="flex justify-between">
                              <div></div>
                              <div class="flex align-center">
                                <p class="text-sm font-semibold">
                                  {transportTypeOrigin === 'LTL' 
                                  ? `${'Leg ' + [i + 1]}` : `${'Vehicle ' + [i + 1]}`}
                                </p>  
                              </div>
                              <div class="flex">
                                { e.tripstatus === 'started' && e.consent == 'ALLOWED' && EXPORT_BOOKING ? 
                                 <button
                                 class='bg-[#C9DEFF] p-1 border-0 rounded-md'
                                >
                                  <img src={TrackIcon} 
                                  onClick={()=>{
                                    console.log("changes------------>", e.publiclink)
                                    if(e.publiclink !== undefined && e.publiclink != ''){
                                      DtStore.MapUrl = e.publiclink
                                      DtStore.modalVisible2 = true
                                      setMapVisible(true)
                                    }
                                  }}
                                  alt="track"/>
                                </button>: ""}
                                {origin.length > 1 && e.consent !== 'ALLOWED' ? (
                                  <button
                                    onClick={(e) => {
                                      e.preventDefault()
                                      transportTypeOrigin === 'LTL' ? 
                                      del1(i, 'deleteWarehouse') : del1(i);
                                    }}
                                    className="ml-2 button is-danger is-inverted"
                                  >
                                    <span className="icon">
                                      <i className="fas fa-trash"></i>
                                    </span>
                                  </button>
                                ) : (
                                  <></>
                                )}
                              </div>
                            </div>
                            <div class="flex py-2">
                              <div class="flex w-[50%]">
                                {
                                  LCL_OR_AIR && booking.ltlversion !== undefined && booking.ltlversion === 'Yes' ? 
                                  <>
                                    <div class="w-2/4 px-4">
                                      <p class="text-sm">{transportTypeOrigin === 'LTL' ? i === 0 ? 'Origin*'
                                      : `${originWarehouses[i-1]}*` : 'Origin*'}</p>
                                      <OneInput5table key1 = {"orgin"+i}
                                        search={true}
                                        name={transportTypeOrigin === 'LTL' ? (i === 0 ) ? 'origin' : (i + 1 === origin.length && origin.length > 1) 
                                          ? `warehouse_${i}` : `warehouse_${i}` : 'origin'}
                                        isValid={transportTypeOrigin === 'LTL' ? (i === 0 ) ? originError?.[i]?.origin : (i + 1 === origin.length && origin.length > 1) 
                                          ? originError?.[i][`warehouse_${i}`] : originError?.[i][`warehouse_${i}`] : originError?.[i]?.origin}
                                        record={JSON.parse(JSON.stringify(e))}
                                        label="Origin"
                                        errorMsg={transportTypeOrigin === 'LTL' ? i === 0 ? 'origin is required' : `warehouse ${i} is required` : "origin is required"}
                                        onChange={(key, value) => updateOrigin(i, key, value)}
                                      />
                                  </div>
                                  <div class="w-2/4 px-4">
                                    <p class="text-sm">{transportTypeOrigin === 'LTL' ? origin.length - 1 === i 
                                    ? EXPORT_BOOKING ? `Destination* - ${JSON.parse(JSON.stringify(e['terminal_cfs']))}` : 'Destination*'
                                    : `${originWarehouses[i]}*` : EXPORT_BOOKING ? `Destination* - ${JSON.parse(JSON.stringify(e['terminal_cfs']))}` : 'Destination*'}</p>
                                    <OneInput5table key1 = {"orgin"+i}
                                      search={true}
                                      name={transportTypeOrigin === 'LTL' ? (i === 0 && origin.length > 1) ? `warehouse_${i+1}` : 
                                        i + 1 === origin.length ?  'destination' : `warehouse_${i+1}` : 'destination'}
                                      isValid={transportTypeOrigin === 'LTL' 
                                        ? (i === 0 && origin.length > 1) 
                                          ? originError?.[i]?.[`warehouse_${i+1}`] 
                                          : i + 1 === origin.length 
                                            ? originError?.[i]?.destination 
                                            : originError?.[i]?.[`warehouse_${i+1}`] 
                                        : originError?.[i]?.destination
                                      }
                                      record={JSON.parse(JSON.stringify(e))}
                                      label="Destination"
                                      errorMsg={transportTypeOrigin === 'LTL' ? (i === 0 && origin.length > 1) ? `warehouse ${i+1} is required` : 
                                      i + 1 === origin.length ?  'destination is required' : `warehouse ${i+1} is required` : 'destination is required'}
                                      onChange={(key, value) => updateOrigin(i, key, value)}
                                    />
                                  </div>
                                </> : 
                                <>
                                  <div class="w-2/4 px-4">
                                    <p class="text-sm">Origin*</p>
                                    <OneInput5table key1 = {"orgin"+i}
                                      search={true}
                                      name="origin"
                                      isValid={originError?.[i]?.origin}
                                      record={JSON.parse(JSON.stringify(e))}
                                      label="Origin"
                                      errorMsg="Origin is required"
                                      onChange={(key, value) => updateOrigin(i, key, value)}
                                    />
                                  </div>
                                  <div class="w-2/4 px-4">
                                    <p class="text-sm">{EXPORT_BOOKING && booking.ltlversion === 'Yes' ? `Destination* - ${JSON.parse(JSON.stringify(e['terminal_cfs']))}` : 'Destination*'}</p>
                                    <OneInput5table key1 = {"orgin"+i}
                                      search={true}
                                      name="destination"
                                      isValid={originError?.[i]?.destination}
                                      record={JSON.parse(JSON.stringify(e))}
                                      label="Destination"
                                      errorMsg="Destination is required"
                                      onChange={(key, value) => updateOrigin(i, key, value)}
                                    />
                                  </div>
                                </>
                                }
                              </div>
                              <div class="flex w-[50%]">

                                { LCL_EXPORT_TRANSPORT || AIR_EXPORT_TRANSPORT ?
                                  <>
                                    <div class="w-2/4 px-4">
                                      <p class="text-sm">Transporter Ref Number</p>
                                      <OneInput5table key1 = {"orgin"+i}
                                        name="transport_ref_number"
                                        record={JSON.parse(JSON.stringify(e))}
                                        label="Transporter Ref Number"
                                        onChange={(key, value) => updateOrigin(i, key, value)}
                                      />
                                    </div>
                                    <div class="w-2/4 px-4">
                                      <p class="text-sm">Transporter Name</p>
                                      <OneInput5table key1 = {"orgin"+i}
                                        search={true}
                                        name="transport_name"
                                        record={JSON.parse(JSON.stringify(e))}
                                        label="Transporter Name"
                                        onChange={(key, value) => updateOrigin(i, key, value)}
                                      />
                                    </div>
                                  </>
                                  : <></> 
                                }
                                <div class="w-2/4 px-4">
                                  <p class="text-sm">{`${transportTypeOrigin === 'LTL' ? i === 0 ? 'No. of Packages*' : 'No. of Packages' : 'No. of Packages*'}`}</p>
                                  <OneInput5table key1 = {"orgin"+i}
                                    disable={transportTypeOrigin === 'LTL' ? i === 0 ? originDisable?.[i] : false : originDisable?.[i]}
                                    name="number_of_package"
                                    isValid={
                                      originError?.[i]?.number_of_package
                                    }
                                    record={JSON.parse(JSON.stringify(e))}
                                    label="Number Of Package"
                                    errorMsg={transportTypeOrigin === 'LTL' ? i === 0 ? 'should be equal to total No.of Packages' : ''
                                      :'Sum of vehicle packages should be equal to total No.of Packages'}
                                    onChange={(key, value) => updateOrigin(i, key, value)}
                                  />
                                </div>
                              </div>
                            </div>
                            <div class="flex px-2 py-2">
                              <div class="w-full px-2">
                                <p class="text-sm">{`${booking.shipmentType !== SHIPMENT_TYPE.lcl ? 'Vehicle Number*' : 'Vehicle Number'}`}</p>
                                <OneInput5table key1 = {"orgin"+i}
                                  name="vehicle"
                                  isValid={originError?.[i]?.vehicle}
                                  record={JSON.parse(JSON.stringify(e))}
                                  label="Vehicle#"
                                  errorMsg={`${booking.shipmentType !== SHIPMENT_TYPE.lcl ? 'Vehicle is required' : ''}`}
                                  onChange={(key, value) => updateOrigin(i, key, value)}
                                />
                              </div>
                              <div class="w-full px-2">
                                <p class="text-sm">Driver Number{`${booking.shipmentType !== SHIPMENT_TYPE.lcl ? '*' : ''}`}</p>
                                <OneInput5table key1 = {"orgin"+i}
                                  disable={e.consent !== 'ALLOWED'}
                                  name="driver_number"
                                  isValid={originError?.[i]?.driver_number}
                                  record={JSON.parse(JSON.stringify(e))}
                                  label="Driver Number"
                                  errorMsg="Enter Valid Phone Number"
                                  onChange={(key, value) => updateOrigin(i, key, value)}
                                />
                              </div>
                              <div class="w-full px-2">
                                <p class="text-sm">Driver Name</p>
                                <OneInput5table key1 = {"orgin"+i}
                                  name="driver_name"
                                  record={JSON.parse(JSON.stringify(e))}
                                  label="Driver Name"
                                  onChange={(key, value) => updateOrigin(i, key, value)}
                                />
                              </div>
                              {Object.entries(transportTypeOrigin === 'LTL' && originDateSelectorForLTL?.length > 0 
                              ? originDateSelectorForLTL[i] : originDateSelector).map(
                                ([key, value], index) => (
                                  <div className="w-full px-2" key={index}>
                                    <p className="text-sm">{value}</p>
                                    <input
                                      disabled= {shipmentYettoStart 
                                        && updatedFreezeFieldsRef.current.includes(key)}
                                      type="date"
                                      value={convertDateFormat(e[key])}
                                      className="border-solid border w-full rounded-md p-1.5"
                                      id={key}
                                      name={key}
                                      max={Object.keys(ACTUALSLIST).includes(key)?today:undefined}
                                      min={key==="arrival_dispatch_airport"?convertDateFormat(e['cargo_pickup']):undefined}
                                      onChange={(event) => {
                                          const newOrigin = origin.map((item, idx) =>
                                            idx === i ? { ...item, [key]: event.target.value } : item
                                          );
                                          setOrgin(newOrigin);
                                      }}
                                    />
                                  </div>
                                )
                              )}
                            </div>
                          </div>
                        );
                      })}

                      <div class="mt-2 flex justify-end">
                      <button
                        className="w-40 h-9 border-0 border-slate-800 bg-custom-gray px-4 py-2 border-transparent text-black font-semibold rounded-md"
                        onClick={(e) =>
                          transportTypeOrigin === "LTL"
                            ? add1(e, "addWareHouses")
                            : add1(e)
                        }
                      >
                        {transportTypeOrigin === "LTL"
                          ? "+ Add Warehouse"
                          : "+ Add Vehicle"}
                      </button>
                      </div>
                    </div>
                  </>
                ) : (
                  <></>
                )}  
                {(sc == SHIPMENT_SCOPE.p2d || sc == SHIPMENT_SCOPE.d2d) && 
                st != SHIPMENT_TYPE.fcl_cfs_f && des && des.length > 0 ? (
                  <div>
                    <div class="px-5 py-2 flex align-center justify-between">
                      <p class="text-base font-semibold">Destination Delivery</p>
                      <div>
                        <div class="flex align-center">
                          <p class="text-base font-semibold">
                            Total No. of Packages: {(+des[0].total_package)}
                          </p>
                        </div>
                      </div>
                      { ret.shipmentType === 'LCL' || ret.shipmentType === 'Air' ? 
                        <div class="flex items-center space-x-4">
                          <span class="font-bold">Transport Type:</span>
                          <label class="flex items-center space-x-2">
                              <input checked={transportTypeDestination === "FTL"} type="radio" name="transport" value="FTL"
                              disabled={booking.ltlversion ? false : true}
                                onChange={(e) => {
                                  if(booking?.vdes?.length > 0){
                                    setClearData(true)
                                    setClearType('destination')
                                    setDestinationDisable([])
                                  }else{
                                    setDes([])
                                    setDestinationWarehouses([])
                                    setDestinationDateSelectorForLTL([])
                                    setDestinationDisable([])
                                    setDestinationOrder(true)
                                    setTransportTypeDestination("FTL");
                                  }
                                }}
                              class="w-5 h-5 text-blue-600 border-gray-300 focus:ring-blue-500" />
                              <span>FTL</span>
                          </label>
                          <label class="flex items-center space-x-2">
                              <input checked={transportTypeDestination === "LTL"} type="radio" name="transport" value="LTL"
                              disabled={booking.ltlversion ? false : true}
                              onChange={() => {
                                if(booking?.vdes?.length > 0){
                                  setClearData(true)
                                  setClearType('destination')
                                  setDestinationDisable([])
                                }else{
                                  setDes([])
                                  setDestinationWarehouses([])
                                  setDestinationDisable([])
                                  setDestinationOrder(true)
                                  setTransportTypeDestination("LTL");
                                }
                              }}
                              class="w-5 h-5 text-blue-600 border-gray-300 focus:ring-blue-500" />
                              <span>LTL</span>
                          </label>
                        </div> : <div></div>
                      }
                    </div>
                    { des && des.length > 0 ? des.map((e, i) => {
                      return (
                        <div class="mb-5 p-5 bg-custom-gray rounded-md">
                          <div class="flex justify-between">
                            <div class="ml-4 flex align-center">
                            {e.consent === 'UNKNOWN' && <button class='p-3 bg-[#C9DEFF] border-0 rounded-md'>Driver Status: {`Invalid Driver Number`}</button>}
                            {((e.consent === 'PENDING') && e?.tripstatus !== 'completed') || (e.consent != undefined && e.consent.indexOf('This Driver Number is already assigned') != -1) ?
                              <>
                              <button class='p-3 bg-[#C9DEFF] border-0 rounded-md'> Driver Status: {e.consent}</button>
                              {e.consent === 'PENDING' && <button onClick={()=>{
                                try {
                                  Api.consentStatus({
                                    driver_number: e.driver_number,
                                    tripId: e.tripId,
                                    bookingId: ret._id,
                                    key: 'vdes'
                                  }, async (response) => {
                                    console.log("error response", response)
                                    configStore.setModalMessage(`Consent is ${response.data}`)
                                    if (response.data === "ALLOWED") {
                                      setDes(prev =>
                                        prev.map((item, index) =>
                                          index === i ? { ...item, consent: "ALLOWED" } : item
                                        )
                                      );
                                      configStore.modalvisibledata = {
                                        ...configStore.modalvisibledata,
                                        vdes: configStore.modalvisibledata.vdes.map(item => ({
                                          ...item,
                                          consent: "ALLOWED"
                                        }))
                                      };
                                    }
                                  });
                            
                                } catch (error) {
                                  configStore.setModalMessage(error)
                                  console.error("Consent update failed:", error);
                                }
                                
                              }} class ='ml-2 p-2 bg-[#C9DEFF] p-1 border-0 rounded-md'><span className="icon"><i className="fas fa-refresh fas fa-lg"></i></span></button>}
                              </>:
                              <>
                                { e.consent === 'ALLOWED' && <button class='p-3 bg-[#C9DEFF] border-0 rounded-md'> Trip Status: {e.tripstatus}</button>} 
                              </>}
                            </div>
                            <div class="flex align-center">
                              <p class="text-sm font-semibold">
                              {transportTypeDestination === 'LTL' 
                                ? `${'Leg ' + [i + 1]}` : `${'Vehicle ' + [i + 1]}`}
                              </p>
                            </div>
                            <div class="flex">
                              { e.tripstatus === 'started' && e.consent == 'ALLOWED' && IMPORT_BOOKING ? 
                                <button
                                class='bg-[#C9DEFF] p-1 border-0 rounded-md'
                              >
                                <img src={TrackIcon} 
                                onClick={()=>{
                                  if(e.publiclink !== undefined && e.publiclink != ''){
                                    DtStore.MapUrl = e.publiclink
                                    DtStore.modalVisible2 = true
                                    setMapVisible(true)
                                  }
                                }}
                                  alt="track"/>
                              </button>: ""}
                              {des.length > 1 && e.consent !== 'ALLOWED' ? (
                                <button
                                  onClick={(e) => {
                                    e.preventDefault();
                                    console.log("transportTypeOrigin", transportTypeOrigin)
                                    transportTypeDestination === 'LTL' ? 
                                    del2(i, 'deleteWarehouse') : del2(i); 
                                  }}
                                  className="ml-2 button is-danger is-inverted"
                                >
                                  <span className="icon">
                                    <i className="fas fa-trash"></i>
                                  </span>
                                </button>
                              ) : (
                                <></>
                              )}
                            </div>
                          </div>
                          <div class="flex py-2">
                            <div class="flex w-[50%]">
                              {
                                LCL_OR_AIR && booking.ltlversion !== undefined && booking.ltlversion === 'Yes' ? 
                                <>
                                  <div class="w-2/4 px-4">
                                    <p class="text-sm">{transportTypeDestination === 'LTL' ? i === 0 ? IMPORT_BOOKING ?
                                    `Origin* - ${JSON.parse(JSON.stringify(e['terminal_cfs']))}` : 'Origin*'
                                    : `${destinationWarehouses[i-1]}*` : IMPORT_BOOKING 
                                    ? `Origin* - ${JSON.parse(JSON.stringify(e['terminal_cfs']))}` : 'Origin*'}</p>
                                    <OneInput5table key1 = {"destination"+i}
                                      search={true}
                                      name={transportTypeDestination === 'LTL' ? (i === 0 ) ? 'origin' : (i + 1 === des.length && des.length > 1) 
                                        ? `warehouse_${i}` : `warehouse_${i}` : 'origin'}
                                      isValid={transportTypeDestination === 'LTL' ? (i === 0 ) ? destinationError?.[i]?.origin : (i + 1 === des.length && des.length > 1) 
                                        ? destinationError?.[i][`warehouse_${i}`] : destinationError?.[i][`warehouse_${i}`] : destinationError?.[i]?.origin}
                                      record={JSON.parse(JSON.stringify(e))}
                                      label="Origin"
                                      errorMsg={transportTypeDestination === 'LTL' ? (i === 0 ) ? 'origin is required' : (i + 1 === des.length && des.length > 1) 
                                        ? `warehouse ${i} is required` : `warehouse ${i} is required` : 'origin is required'}
                                      onChange={(key, value) => updateDestination(i, key, value, (transportTypeDestination === 'LTL' && destinationWarehouses.length > 0) )}
                                    />
                                  </div>
                                  <div class="w-2/4 px-4">
                                    <p class="text-sm">{transportTypeDestination === 'LTL' ? des.length - 1 === i ? 'Destination*'
                                    : `${destinationWarehouses[i]}*` : 'Destination*'}</p>
                                    <OneInput5table key1 = {"destination"+i}
                                      search={true}
                                      name={transportTypeDestination === 'LTL' ? (i === 0 && des.length > 1) ? `warehouse_${i+1}` : 
                                          i + 1 === des.length ?  'destination' : `warehouse_${i+1}` : 'destination'}
                                      isValid={transportTypeDestination === 'LTL' 
                                        ? (i === 0 && des.length > 1) 
                                          ? destinationError?.[i]?.[`warehouse_${i+1}`] 
                                          : i + 1 === des.length 
                                            ? destinationError?.[i]?.destination 
                                            : destinationError?.[i]?.[`warehouse_${i+1}`] 
                                        : destinationError?.[i]?.destination
                                      }
                                      record={JSON.parse(JSON.stringify(e))}
                                      label="Destination"
                                      errorMsg={transportTypeDestination === 'LTL' ? (i === 0 && des.length > 1) ? `warehouse ${i+1} is required` : 
                                      i + 1 === des.length ?  'destination is required' : `warehouse ${i+1} is required` : 'destination is required'}
                                      onChange={(key, value) => updateDestination(i, key, value)}
                                    />
                                  </div>
                                </> : 
                                <>
                                  <div class="w-2/4 px-4">
                                    <p class="text-sm">{IMPORT_BOOKING && booking.ltlversion === 'Yes' ?  `Origin* - ${JSON.parse(JSON.stringify(e['terminal_cfs']))}` : 'Origin*'}</p>
                                    <OneInput5table key1 = {"destination"+i}
                                      search={true}
                                      name="origin"
                                      isValid={destinationError[i].origin}
                                      record={JSON.parse(JSON.stringify(e))}
                                      label="Origin"
                                      errorMsg="Origin is required"
                                      onChange={(key, value) => updateDestination(i, key, value)}
                                    />
                                  </div>
                                  <div class="w-2/4 px-4">
                                    <p class="text-sm">Destination*</p>
                                    <OneInput5table key1 = {"destination"+i}
                                      search={true}
                                      name="destination"
                                      isValid={destinationError[i].destination}
                                      record={JSON.parse(JSON.stringify(e))}
                                      label="Destination"
                                      errorMsg="Destination is required"
                                      onChange={(key, value) => updateDestination(i, key, value)}
                                    />
                                  </div>
                                </>
                              }
                              { (booking.shipmentType === SHIPMENT_TYPE.fcl_cfs_cfs || booking.shipmentType === SHIPMENT_TYPE.fcl_f_cfs) &&
                                <div class="w-2/4 px-4">
                                  <p class="text-sm">Container Number*</p>
                                  <OneInput5table key1 = {"destination"+i}
                                    name="container_number_vehicle"
                                    isValid={destinationError[i].container_number_vehicle}
                                    record={JSON.parse(JSON.stringify(e))}
                                    label="Container Number"
                                    errorMsg="Container Number is required"
                                    onChange={(key, value) => updateDestination(i, key, value)}
                                  />
                              </div>
                              }
                            </div>
                            <div class="flex w-[50%]">
                              { (LCL_IMPORT_TRANSPORT || AIR_IMPORT_TRANSPORT) ? 
                                <>
                                  <div class="w-2/4 px-4">
                                    <p class="text-sm">Transporter Ref Number</p>
                                    <OneInput5table key1 = {"destination"+i}
                                      name="transport_ref_number"
                                      record={JSON.parse(JSON.stringify(e))}
                                      label="Transporter Ref Number"
                                      onChange={(key, value) => updateDestination(i, key, value)}
                                    />
                                  </div>
                                  <div class="w-2/4 px-4">
                                    <p class="text-sm">Transporter Name</p>
                                    <OneInput5table key1 = {"destination"+i}
                                      search={true}
                                      name="transport_name"
                                      record={JSON.parse(JSON.stringify(e))}
                                      label="Transporter Name"
                                      onChange={(key, value) => updateDestination(i, key, value)}
                                    />
                                  </div>
                                </> 
                                : <></>
                              }
                              <div class="w-2/4 px-4">
                                <p class="text-sm">{`${transportTypeDestination === 'LTL' ? i === 0 ? 'No. of Packages*' : 'No. of Packages' : 'No. of Packages*'}`}</p>
                                <OneInput5table key1 = {"destination"+i}
                                  disable={transportTypeDestination === 'LTL' ? i === 0 ? destinationDisable?.[i] : false : destinationDisable?.[i]}
                                  name="number_of_package"
                                  isValid={destinationError[i].number_of_package}
                                  record={JSON.parse(JSON.stringify(e))}
                                  label="Number Of Package"
                                  errorMsg={transportTypeDestination === 'LTL' ? i === 0 ? 'should be equal to total No.of Packages' : ''
                                    :'Sum of vehicle packages should be equal to total No.of Packages'}
                                  onChange={(key, value) => updateDestination(i, key, value)}
                                />
                              </div>
                            </div>
                          </div>
                          <div class="flex px-2 py-2">
                            <div class="w-full px-2">
                              <p class="text-sm">{`${booking.shipmentType !== SHIPMENT_TYPE.lcl ? 'Vehicle Number*' : 'Vehicle Number'}`}</p>
                              <OneInput5table key1 = {"destination"+i}
                                name="vehicle"
                                isValid={destinationError?.[i]?.vehicle}
                                record={JSON.parse(JSON.stringify(e))}
                                label="Vehicle#"
                                errorMsg={`${booking.shipmentType !== SHIPMENT_TYPE.lcl ? 'Vehicle is required' : ''}`}
                                onChange={(key, value) => updateDestination(i, key, value)}
                              />
                            </div>
                            <div class="w-full px-2">
                              <p class="text-sm">Driver Number{`${booking.shipmentType !== SHIPMENT_TYPE.lcl ? '*' : ''}`}</p>
                              <OneInput5table key1 = {"destination"+i}
                                disable={e.consent !== 'ALLOWED'}
                                name="driver_number"
                                isValid={destinationError[i].driver_number}
                                record={JSON.parse(JSON.stringify(e))}
                                label="Driver Number"
                                errorMsg="Enter Valid Phone Number"
                                onChange={(key, value) => updateDestination(i, key, value)}
                              />
                            </div>
                            <div class="w-full p  x-2">
                              <p class="text-sm">Driver Name</p>
                              <OneInput5table key1 = {"destination"+i}
                                name="driver_name"
                                record={JSON.parse(JSON.stringify(e))}
                                label="Driver Name"
                                onChange={(key, value) => updateDestination(i, key, value)}
                              />
                            </div>
                            {Object.entries(transportTypeDestination === 'LTL' && destinationDateSelectorForLTL?.length > 0 
                          ? destinationDateSelectorForLTL[i] : destinationDateSelector).map(
                            ([key, value], index) => {
                              let minDate = "";

                              // Get the list of keys
                              const keysArray = Object.keys(ACTUALSLIST);
                              const keyIndex = keysArray.indexOf(key);

                              if (keyIndex > 0) {
                                for (let i = keyIndex - 1; i >= 0; i--) {
                                  const prevKey = keysArray[i];

                                  // Check directly in ret
                                  if (ret[prevKey]) {
                                    minDate = ret[prevKey];
                                    break;
                                  }

                                  let latestDate = "";

                                  for (const listKey of arrayListsinDsr) {
                                    if (Array.isArray(ret[listKey])) { 
                                      for (const item of ret[listKey]) { 
                                        if (item[prevKey] && (!latestDate || new Date(item[prevKey]) < new Date(latestDate))) {
                                          latestDate = item[prevKey];
                                        }
                                      }
                                    }
                                  }
                                  if (latestDate) {
                                    minDate = latestDate;
                                    break;
                                  }
                                }
                              } return(
                                <div className="w-full px-2" key={index}>
                                  <p className="text-sm">{value}</p>
                                  <input
                                    disabled= {shipmentYettoStart 
                                      && updatedFreezeFieldsRef.current.includes(key)}
                                    type="date"
                                    value={convertDateFormat(e[key])}
                                    className="border-solid border w-full rounded-md p-1.5"
                                    id={key}
                                    min={minDate ? minDate.split("-").reverse().join("-") : ""}
                                    max={keysArray.includes(key) ? today : undefined}
                                    name={key}
                                    onChange={(event) => {
                                      const newdes = des.map((item, idx) =>
                                        idx === i ? { ...item, [key]:  event.target.value } : item
                                      );
                                      setDes(newdes)
                                    }}
                                  />
                                </div>
                              )
                            })}
                          </div>
                        </div>
                      )
                    }) : <></>}
                    <div class="mt-2 flex justify-end">
                    <button
                      className="w-40 h-9 border-0 border-slate-800 bg-custom-gray px-4 py-2 border-transparent text-black font-semibold rounded-md"
                      onClick={(e) =>
                        transportTypeDestination === "LTL"
                          ? add2(e, "addWareHouses")
                          : add2(e)
                      }
                    >
                      {transportTypeDestination === "LTL"
                        ? "+ Add Warehouse"
                        : "+ Add Vehicle"}
                    </button>
                    </div>
                  </div>
                ) : (
                  <></>
                )}

                {(sc == SHIPMENT_SCOPE.p2d || sc == SHIPMENT_SCOPE.d2d) && st != SHIPMENT_TYPE.fcl_cfs_f
                && multipleDes && multipleDes.length > 0 ? multipleDes.map((ele, index) =>{
                  return (
                    <div class='mt-5' key={index + "1"}>
                      <div class="px-5 py-2 grid grid-cols-3 items-center w-full">
                        <p class="text-base font-semibold">
                          Destination Delivery: {index + 1} 
                        </p>
                        <p class="text-base font-semibold col-start-2 col-span-1 text-center">
                          Total No. of Packages: 
                          {(+multipleDes[index][0].total_package)}
                        </p>
                        { index === 0 && (ret.shipmentType === 'LCL' || ret.shipmentType === 'Air') ? 
                          <div class="flex items-center ml-auto space-x-4">
                            <span class="font-bold">Transport Type:</span>
                            <label class="flex items-center space-x-2">
                                <input  key={index} checked={transportTypeDestination === "FTL"} type="radio" 
                                name="transportTypeDestination" value="FTL"
                                disabled={booking.ltlversion ? false : true}
                                  onChange={() => {
                                    if(booking?.vdes?.length > 0){
                                      setClearData(true)
                                      setClearType('Multiple')
                                      setDestinationDisable([])
                                    }else{
                                      setMultipleDes([])
                                      setDestinationWarehouses([])
                                      setDestinationDateSelectorForLTL([])
                                      setDestinationDisable([])
                                      setDestinationOrder(true)
                                      setTransportTypeDestination("FTL");
                                    }
                                  }}
                                class="w-5 h-5 text-blue-600 border-gray-300 focus:ring-blue-500" />
                                <span>FTL</span>
                            </label>
                            <label class="flex items-center space-x-2">
                                <input key={index+1} checked={transportTypeDestination === "LTL"} type="radio" 
                                name="transportTypeDestination" value="LTL"
                                disabled={booking.ltlversion ? false : true}
                                onChange={() => {
                                  if(booking?.vdes?.length > 0){
                                    setClearData(true)
                                    setClearType('Multiple')
                                    setDestinationDisable([])
                                  }else{
                                    setMultipleDes([])
                                    setDestinationWarehouses([])
                                    setDestinationDisable([])
                                    setDestinationOrder(true)
                                    setTransportTypeDestination("LTL");
                                  }}
                                }
                                class="w-5 h-5 text-blue-600 border-gray-300 focus:ring-blue-500" />
                                <span>LTL</span>
                            </label>
                          </div> : <div></div>
                        }
                      </div>
                      {
                        ele.map((e, i, desArr) => {
                          return(
                            <div key={i+"11"}>
                              <div class="mb-5 p-5 bg-custom-gray rounded-md">
                                <div class="flex justify-between">
                                  <div class="ml-4 flex align-center">
                                    {e.consent === 'UNKNOWN' && <button class='p-3 bg-[#C9DEFF] border-0 rounded-md'>Driver Status: {`Invalid Driver Number`}</button>}
                                    {((e.consent === 'PENDING') && e?.tripstatus !== 'completed') || (e.consent != undefined && e.consent.indexOf('This Driver Number is already assigned') != -1)? 
                                    <>
                                    <button class='p-3 bg-[#C9DEFF] border-0 rounded-md'> Driver Status: {e.consent}</button>
                                    {e.consent === 'PENDING' && <button onClick={()=>{
                                      const result = Api.consentStatus({driver_number : e.driver_number, tripId: e.tripId, bookingId: ret._id, key: index === 0 ? 'vdes' : `vdes${index+1}` })
                                      if (result?.data === "ALLOWED") {
                                        setMultipleDes(prev =>
                                          prev.map((group, groupIndex) =>
                                            groupIndex === index
                                              ? group.map((item, itemIndex) =>
                                                  itemIndex === i ? { ...item, consent: "ALLOWED" } : item
                                                )
                                              : group
                                          )
                                        );
                                        let key = index === 0 ? 'vdes' : `vdes${index+1}`
                                        configStore.modalvisibledata = {
                                          ...configStore.modalvisibledata,
                                          [key]: configStore.modalvisibledata.key.map(item => ({
                                            ...item,
                                            consent: "ALLOWED"
                                          }))
                                        };
                                      }
                                      console.log("result====================", result)
                                      
                                    }} class ='ml-2 p-2 bg-[#C9DEFF] p-1 border-0 rounded-md'><span className="icon"><i className="fas fa-refresh fas fa-lg"></i></span></button>}
                                    </>:
                                    <>
                                      { e.consent === 'ALLOWED' && <button class='p-3 bg-[#C9DEFF] border-0 rounded-md'> Trip Status: {e.tripstatus}</button>} 
                                    </>}
                                  </div>
                                  <div class="flex align-center">
                                    <p class="text-sm font-semibold">
                                    {transportTypeDestination === 'LTL' 
                                      ? `${'Leg ' + [i + 1]}` : `${'Vehicle ' + [i + 1]}`}
                                    </p>
                                  </div>
                                  <div class="flex">
                                    { e.tripstatus === 'started' && e.consent == 'ALLOWED' && IMPORT_BOOKING ? 
                                      <button
                                      class='bg-[#C9DEFF] p-1 border-0 rounded-md'
                                      >
                                        <img src={TrackIcon} 
                                          onClick={()=>{
                                            if(e.publiclink !== undefined && e.publiclink != ''){
                                              DtStore.MapUrl = e.publiclink
                                              DtStore.modalVisible2 = true
                                              setMapVisible(true)
                                            }
                                          }}
                                          alt="track"/>
                                      </button>: ""
                                    }
                                    {ele && ele.length > 1 && e.consent !== 'ALLOWED' ? (
                                      <button
                                        onClick={(e) => {
                                          e.preventDefault();
                                          transportTypeDestination === "LTL"
                                          ? removeMultiDestination(index, i, "addWareHouses")
                                          : removeMultiDestination(index, i);
                                          
                                        }}
                                        className="ml-2 button is-danger is-inverted"
                                      >
                                        <span className="icon">
                                          <i className="fas fa-trash"></i>
                                        </span>
                                      </button>
                                    ) : (
                                      <></>
                                    )}
                                  </div>
                                </div>
                                <div class="flex py-2">
                                  <div class="flex w-[50%]">
                                    {
                                      LCL_OR_AIR && booking.ltlversion !== undefined && booking.ltlversion === 'Yes' ? 
                                      <>
                                        <div class="w-2/4 px-4">
                                          <label class="text-sm">{transportTypeDestination === 'LTL' ? i === 0 ?
                                          IMPORT_BOOKING ? `Origin* - ${JSON.parse(JSON.stringify(e['terminal_cfs']))}` : 'Origin*'
                                          : `${destinationWarehouses[index][i-1]}*` : IMPORT_BOOKING ? `Origin* - ${JSON.parse(JSON.stringify(e['terminal_cfs']))}` : 'Origin*'}</label>
                                          <OneInput5table key1 = {index+"destination"+i}
                                            search={true}
                                            name={transportTypeDestination === 'LTL' ? (i === 0 ) ? 'origin' : (i + 1 === desArr.length && desArr.length > 1) 
                                              ? `warehouse_${i}` : `warehouse_${i}` : 'origin'}
                                            isValid={transportTypeDestination === 'LTL' ? (i === 0 ) ? multidestError[index][i]?.origin : (i + 1 === desArr.length && desArr.length > 1) 
                                              ? multidestError[index][i][`warehouse_${i}`] : multidestError[index][i][`warehouse_${i}`] : multidestError[index][i]?.origin}
                                            record={JSON.parse(JSON.stringify(e))}
                                            label="Origin"
                                            errorMsg={transportTypeDestination === 'LTL' ? (i === 0 ) ? 'origin is required' : (i + 1 === desArr.length && desArr.length > 1) 
                                              ? `warehouse ${i} is required` : `warehouse ${i} is required` : 'origin is required'}
                                            onChange={(key, value) => updateMultiplDes(index, i, key, value)}
                                          />
                                        </div>
                                        <div class="w-2/4 px-4">
                                          <label htmlFor='warehouse 1' class="text-sm">{transportTypeDestination === 'LTL' ? ele.length - 1 === i 
                                          ? 'Destination*' : `${destinationWarehouses[index][i]}*` : 'Destination*'}</label>
                                          <OneInput5table key1 = {index+"destination"+i}
                                            search={true}
                                            name={transportTypeDestination === 'LTL' ? (i === 0 && desArr.length > 1) ? `warehouse_${i+1}` : 
                                                i + 1 === desArr.length ?  'destination' : `warehouse_${i+1}` : 'destination'}
                                            isValid={transportTypeDestination === 'LTL' 
                                              ? (i === 0 && desArr.length > 1) 
                                                ? multidestError[index][i]?.[`warehouse_${i+1}`] 
                                                : i + 1 === desArr.length 
                                                  ? multidestError[index][i]?.destination 
                                                  : multidestError[index][i]?.[`warehouse_${i+1}`] 
                                              : multidestError[index][i]?.destination
                                            }
                                            record={JSON.parse(JSON.stringify(e))}
                                            label="Destination"
                                            errorMsg={transportTypeDestination === 'LTL' ? (i === 0 && des.length > 1) ? `warehouse ${i+1} is required` : 
                                            i + 1 === des.length ?  'destination is required' : `warehouse ${i+1} is required` : 'destination is required'}
                                            onChange={(key, value) => updateMultiplDes(index, i, key, value)}
                                          />
                                        </div>
                                      </> : 
                                      <>
                                        <div class="w-2/4 px-4">
                                          <p class="text-sm">{IMPORT_BOOKING && booking.ltlversion === 'Yes' ?  `Origin* - ${JSON.parse(JSON.stringify(e['terminal_cfs']))}` : 'Origin*'}</p>
                                          <OneInput5table key1 = {index+"destination"+i}
                                            search={true}
                                            name="origin"
                                            isValid={multidestError[index][i].origin}
                                            record={JSON.parse(JSON.stringify(e))}
                                            label="Origin"
                                            errorMsg="Origin is required"
                                            onChange={(key, value) => updateMultiplDes(index, i, key, value)}
                                          />
                                        </div>
                                        <div class="w-2/4 px-4">
                                          <p class="text-sm">Destination*</p>
                                          <OneInput5table key1 = {index+"destination"+i}
                                            search={true}
                                            name="destination"
                                            isValid={multidestError[index][i].destination}
                                            record={JSON.parse(JSON.stringify(e))}
                                            label="Destination"
                                            errorMsg="Destination is required"
                                            onChange={(key, value) => updateMultiplDes(index, i, key, value)}
                                          />
                                        </div>
                                      </>
                                    }
                                    { (booking.shipmentType === SHIPMENT_TYPE.fcl_cfs_cfs || booking.shipmentType === SHIPMENT_TYPE.fcl_f_cfs) &&
                                      <div class="w-2/4 px-4">
                                        <p class="text-sm">Container Number*</p>
                                        <OneInput5table key1 = {index+"destination"+i}
                                          name="container_number_vehicle"
                                          isValid={multidestError[index][i].container_number_vehicle}
                                          record={JSON.parse(JSON.stringify(e))}
                                          label="Container Number"
                                          errorMsg="Container Number is required"
                                          onChange={(key, value) => updateMultiplDes(index, i, key, value)}
                                        />
                                      </div>
                                    }
                                  </div>
                                  <div class="flex w-[50%]">
                                    {
                                      (LCL_IMPORT_TRANSPORT || AIR_IMPORT_TRANSPORT) ? 
                                      <>
                                        <div class="w-2/4 px-4">
                                          <p class="text-sm">Transporter Ref Number</p>
                                          <OneInput5table key1 = {index+"destination"+i}
                                            name="transport_ref_number"
                                            record={JSON.parse(JSON.stringify(e))}
                                            label="Transporter Ref Number"
                                            onChange={(key, value) => updateMultiplDes(index, i, key, value)}
                                          />
                                        </div>
                                        <div class="w-2/4 px-4">
                                          <p class="text-sm">Transporter Name</p>
                                          <OneInput5table key1 = {index+"destination"+i}
                                            name="transport_name"
                                            record={JSON.parse(JSON.stringify(e))}
                                            label="Transporter Name"
                                            onChange={(key, value) => updateMultiplDes(index, i, key, value)}
                                          />
                                        </div>
                                      </> 
                                      : <></>
                                    }
                                    <div class="w-2/4 px-4">
                                    <p class="text-sm">{`${transportTypeDestination === 'LTL' ? i === 0 ? 'No. of Packages*' : 'No. of Packages' : 'No. of Packages*'}`}</p>
                                      <OneInput5table key1 = {index+"destination"+i}
                                        disable={transportTypeDestination === 'LTL' ? i === 0 ? destinationDisable?.[index]?.[i] : false : destinationDisable?.[index]?.[i]}
                                        name="number_of_package"
                                        isValid={ multidestError[index][i].number_of_package }
                                        record={JSON.parse(JSON.stringify(e))}
                                        label="Number Of Package"
                                        errorMsg={transportTypeDestination === 'LTL' ? i === 0 ? 'should be equal to total No.of Packages' : ''
                                          :'Sum of vehicle packages should be equal to total No.of Packages'}
                                        onChange={(key, value) => updateMultiplDes(index, i, key, value)}
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div class="flex px-2 py-2">
                                  <div class="w-full px-2">
                                    <p class="text-sm">{`${booking.shipmentType !== SHIPMENT_TYPE.lcl ? 'Vehicle Number*' : 'Vehicle Number'}`}</p>
                                    <OneInput5table key1 = {index+"destination"+i}
                                      name="vehicle"
                                      isValid={multidestError[index][i].vehicle}
                                      record={JSON.parse(JSON.stringify(e))}
                                      label="Vehicle#"
                                      errorMsg={`${booking.shipmentType !== SHIPMENT_TYPE.lcl ? 'Vehicle is required*' : ''}`}
                                      onChange={(key, value) => updateMultiplDes(index, i, key, value)}
                                    />
                                  </div>
                                  <div class="w-full px-2">
                                    <p class="text-sm">Driver Number{`${booking.shipmentType !== SHIPMENT_TYPE.lcl ? '*' : ''}`}</p>
                                    <OneInput5table key1 = {index+"destination"+i}
                                      disable={e.consent !== 'ALLOWED'}
                                      name="driver_number"
                                      isValid={multidestError[index][i].driver_number}
                                      record={JSON.parse(JSON.stringify(e))}
                                      label="Driver Number"
                                      errorMsg="Enter Valid Phone Number"
                                      onChange={(key, value) => updateMultiplDes(index, i, key, value)}
                                    />
                                  </div>
                                  <div class="w-full px-2">
                                    <p class="text-sm">Driver Name</p>
                                    <OneInput5table key1 = {index+"destination"+i}
                                      name="driver_name"
                                      record={JSON.parse(JSON.stringify(e))}
                                      label="Driver Name"
                                      onChange={(key, value) => updateMultiplDes(index, i, key, value)}
                                    />
                                  </div>
                                  {Object.entries((transportTypeDestination === 'LTL' && destinationDateSelectorForLTL?.length > 0 
                              ? destinationDateSelectorForLTL[index][i] : destinationDateSelector)).map(
                                    ([key, value], destinationDateSelectorIndex) => {
  let minDate = "";
  const keysArray = Object.keys(ACTUALSLIST);
  const keyIndex = keysArray.indexOf(key);

  if (keyIndex > 0) {
    for (let i = keyIndex - 1; i >= 0; i--) {
      const prevKey = keysArray[i];

      if (ret?.[prevKey]) {
        minDate = ret[prevKey];
        break;
      }

      let latestDate = "";

      for (const listKey of arrayListsinDsr) {
        if (Array.isArray(ret?.[listKey])) {
          for (const item of ret[listKey]) {
            if (item[prevKey] && (!latestDate || new Date(item[prevKey]) < new Date(latestDate))) {
              latestDate = item[prevKey];
            }
          }
        }
      }

      if (latestDate) {
        minDate = latestDate;
        break;
      }
    }
  }

  const formattedMinDate = minDate ? minDate.split("-").reverse().join("-") : "";

  return (
    <div className="w-full px-2" key={destinationDateSelectorIndex}>
      <p className="text-sm">{value}</p>
      <input
        disabled= {ret?.booking?.status === "SUBMITTED" 
          && updatedFreezeFieldsRef.current.includes(key)}
        type="date"
        value={convertDateFormat(e[key])}
        min={formattedMinDate}
        max={keysArray.includes(key) ? today : undefined}
        className="border-solid border w-full rounded-md p-1.5"
        id={key}
        name={key}
        onChange={(event) => {
          const newdes = multipleDes.map((outerItem, oIdx) =>
            oIdx === index
              ? outerItem.map((item, iIdx) =>
                  iIdx === i ? { ...item, [key]: event.target.value } : item
                )
              : outerItem
          );
          setMultipleDes(newdes);
        }}
      />
    </div>
  );
})}
                                </div>
                              </div>
                            </div>
                          )
                        })
                      }
                      <div class="mt-2 mb-2 flex justify-end">
                        <button
                          onClick={(e) => {
                            e.preventDefault(); 
                            transportTypeDestination === "LTL"
                            ? addMultiDestination(index, "addWareHouses")
                            : addMultiDestination(index)
                          }}
                          class="w-40 h-9 border-0 border-slate-800 bg-custom-gray px-4 py-2 border-transparent text-black font-semibold rounded-md"
                        >
                          {transportTypeDestination === 'LTL' ? '+ Add Warehouse' : '+ Add Vehicle'}
                        </button>
                      </div>
                    </div>
                  )
                })
                : <></> }
                <div class="mt-5 flex justify-end">
                  <button
                    class="w-32 mr-3 h-9 text-blue border-0 border-slate-800 bg-custom-gray px-4 py-2 border-transparent text-black font-semibold rounded-md"
                    onClick={() => {
                      myactionsstore.vModalVisible = false;
                      setOrgin([])
                      setDes([])
                      setMultipleDes([])
                    }}
                  >
                    Cancel
                  </button>
                  <button
                    class="w-32 ml-3 h-9 text-blue bg-blue border-0 border-slate-800 bg-custom-gray px-4 py-2 border-transparent text-black font-semibold rounded-md"
                    onClick={(e) => {
                      e.preventDefault();
                      onsave()
                    }}
                  >
                    Save
                  </button>
                </div>
              </div>
            </section>
            
          </div>
        </div>
        { clearData &&
        <div className='modal is-active' >
              <div className="modal-background" ></div>
                <div className="modal-card" onClick={(e) => { e.stopPropagation() }} style={{ borderRadius: '10px' }} >
                <section className="modal-card-body" >

                  <h2 style={{ color: "red" }}>Please note, all the data entered in Vehicle Tracking will be Cleared. </h2>
                                              <br></br>
                                              <button type="submit" class="button is-danger" style={{ float: "right" }}
                                                  onClick={async (e)=>{
                                                    e.preventDefault();
                                                    handleStopTracking(clearType, booking?._id)
                                                    
                                                  }}
                                              >Yes</button>
                                              <button class="button is-warning" onClick={() => {
                                                setClearData(false)
                                              }} >No</button>
                  </section>
            </div></div>}
        { mapVisible && <DtMap /> }
    </>
  );
  };

  
